var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    { attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20" } },
    [
      _c("path", {
        attrs: {
          fill: "red",
          d:
            "M9.651 11.569c.034-.005.057-.01.089-.016-.062-.029-.124-.057-.192-.09-.017.019-.03.04-.048.058-.031.031-.068.054-.101.082l.133-.018.119-.016zM9.787 7.987a2.717 2.717 0 00-.284-.18c-.052-.029-.102-.059-.156-.084-.091-.043-.186-.074-.28-.106-.082-.026-.162-.057-.246-.075-.044-.01-.089-.012-.133-.019a2.522 2.522 0 00-.23-.023v.547l1.404.002c-.026-.021-.05-.043-.075-.062zM10.039 11.812a7.765 7.765 0 01-1.581.192v.501a2.613 2.613 0 001.399-.544c.061-.048.124-.094.182-.149zM10.02 10.196c.251-.036.558-.108.795-.182l.001-.011v-.001a4.381 4.381 0 00-.704-.2c-.034-.007-.076-.009-.111-.015v.412c.006-.002.013-.002.019-.003zM10.001 8.194l.036.008a1.172 1.172 0 00-.036-.035v.027zM10.389 8.605l-.008-.01a6.476 6.476 0 00-.379-.087v.188a3.63 3.63 0 00.387-.091zM10.547 8.897a6.944 6.944 0 01-.546.125v.441c.04.007.087.01.126.017.265.053.482.112.653.174a3.719 3.719 0 00-.076-.352 2.405 2.405 0 00-.157-.405zM10.032 10.518h-.002c.236.173.431.331.574.466.081-.192.137-.405.174-.626-.199.057-.46.113-.746.16z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "red",
          d:
            "M19 10a9 9 0 00-9-9c-.582 0-1.149.06-1.7.165V7.16h.08v-.025l.002-.006c.001-.002.004-.002.006-.002h.062c.005 0 .008.004.008.008v.052c.894.052 1.679.51 2.162 1.203.031.016.065.032.085.047l.002.002.066.105c.001.001-.001.002-.001.004v.001l-.001.001c0 .002.001.004-.001.005l-.003.001c-.003.003-.015.007-.02.01l.055.094c.011.007.033.015.038.021l.046.082c.001.002 0 .004-.001.005v.004a.014.014 0 01-.006.002h-.001c-.004.004-.023.011-.033.017.021.045.048.086.067.132.014.034.02.072.033.106.05.134.098.27.127.413.026.127.032.258.04.388.015.013.038.025.049.038l.002.005V9.951l-.001.003-.002.001-.002.002h-.001c-.004.005-.019.01-.026.015v.104l.001.014c.008.008.023.015.03.023a.008.008 0 01.002.005V10.193l-.001.004-.002.001-.002.002h-.001c-.008.009-.034.019-.049.029-.009.114-.013.229-.036.34-.024.117-.066.226-.103.337-.021.061-.032.125-.057.184-.023.055-.055.105-.082.158.022.043.031.081.017.107v.001l-.036.055-.003.006-.004.008a.002.002 0 01-.002.002l-.005.001-.002.001h-.001c-.007.003-.014.007-.027.007l-.01-.002-.163.253c0 .002.003.005.004.006.003.013-.001.023-.004.033l.001.003-.001.002-.001.008-.035.055-.002.002-.016.013a.008.008 0 01-.005.002.01.01 0 01-.007-.003v-.001c-.01.004-.016.014-.03.014a.302.302 0 01-.04-.003 2.812 2.812 0 01-2.001 1.009v.056l-.002.006c-.001.002-.004.002-.006.002h-.062a.008.008 0 01-.008-.008v-.025H8.3v5.979A9 9 0 0019 10z"
        }
      }),
      _c("path", {
        attrs: { fill: "red", d: "M10.581 11.709l.002-.009-.003.004z" }
      }),
      _c("path", {
        attrs: {
          fill: "#060",
          d:
            "M6.717 10.945c-.08.016-.156.037-.233.056.077-.02.158-.028.236-.044l-.003-.012zM7.188 11.593c-.031-.027-.064-.048-.094-.077a1.695 1.695 0 01-.219-.269c-.153.029-.317.049-.456.089-.061.017-.13.041-.198.068l.003.004c.328.073.656.143.964.185zM6.534 11.792a2.562 2.562 0 001.008.6c.06.019.119.041.181.055.113.029.232.041.352.052l.066.006v-.502c-.038-.004-.076-.005-.114-.011a7.787 7.787 0 01-1.493-.2zM5.813 10.347c.006.04.004.082.012.122.045.224.131.437.236.646a3.847 3.847 0 01.651-.184 1.663 1.663 0 01-.099-.409 5.63 5.63 0 01-.8-.175zM5.661 8.921l.005.009c-.003-.01-.004-.019-.003-.027 0 .006-.004.01-.002.018zM6.536 8.516l.057.024v-.036c-.02.003-.037.008-.057.012zM7.606 7.594c-.065.019-.13.035-.193.059-.081.03-.158.07-.235.109-.074.037-.148.072-.217.116-.042.026-.08.055-.119.082-.036.026-.068.057-.103.085l1.4.002V7.5c-.101.006-.202.011-.3.03-.079.016-.155.041-.233.064zM6.541 8.211l.052-.013v-.033c-.012.011-.025.019-.036.03l-.016.016zM5.78 10.008c.295.092.646.159.813.187v-.41c-.047.008-.104.012-.15.021-.228.045-.471.11-.662.182l-.001.015v.005zM5.874 9.358c-.006.023-.015.045-.02.068-.016.07-.02.148-.031.221a4.03 4.03 0 01.46-.13 5.338 5.338 0 01-.366-.283c-.013.043-.031.081-.043.124z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#060",
          d:
            "M8.218 12.855v.025l-.002.006c-.001.002-.004.002-.006.002h-.063a.008.008 0 01-.008-.008v-.055a2.82 2.82 0 01-1.849-.819 2.725 2.725 0 01-.318-.384c-.018-.007-.047-.015-.064-.023l-.004-.003-.034-.057-.001-.005.001-.002.005-.009h.001l.007-.01-.072-.118-.028-.008-.004-.003h-.001l-.033-.059-.001-.005.003-.004v-.002l.002-.001c.002-.01.018-.02.025-.03a2.765 2.765 0 01-.297-1.059c-.014-.007-.039-.016-.048-.022-.003-.001-.004-.004-.004-.007v-.078-.003l.003-.003.002-.003h.001c.002-.006.014-.012.018-.018v-.122a.39.39 0 01-.02-.009l-.002-.007v-.078-.003l.003-.003.001-.002h.001c.005-.013.028-.027.042-.041.02-.304.08-.596.189-.867-.005-.01-.016-.024-.018-.033-.004-.016.001-.029.005-.041-.002-.003-.003-.005-.002-.007l.003-.007.001-.006.033-.058a.01.01 0 01.01-.004l.005.002c.004-.002.012-.001.017-.002V8.8l.148-.274c-.005-.018-.015-.037-.011-.051l-.001-.002v-.001-.002-.001l.005-.009.034-.059h.001l.003-.005.002-.003c.017-.013.052-.013.084-.015.093-.13.192-.256.305-.369a2.819 2.819 0 011.852-.822v-.051-.001c0-.005.004-.008.008-.008h.062c.005 0 .008.004.008.008v.025H8.3V1.165C4.143 1.961 1 5.611 1 10c0 4.389 3.143 8.039 7.3 8.835v-5.979h-.082z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M9.885 11.528a8.7 8.7 0 00.395-.078 7.009 7.009 0 00-.467-.371c-.058.114-.128.22-.212.32.102.047.196.091.284.129zM6.029 8.934c-.006.013-.015.026-.021.04-.025.056-.041.117-.061.175.117.103.269.22.443.343l.042-.01c.049-.01.11-.013.161-.022v-.3a5.811 5.811 0 00-.564-.226z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M10.58 11.704l.002-.004.001-.005c-.001-.003-.006-.008-.006-.01.001.006.004.013.003.019z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M9.856 11.533c-.085-.038-.171-.076-.265-.121l-.032.038c.074.036.142.068.209.098l.088-.015zM10.79 11.414l.004-.006c.003-.006.003-.011.003-.026v-.009l-.026.04c.004 0 .016.003.019.001zM5.869 8.478s-.001 0 0 0c-.003.007.007.018.007.026l.022-.04c-.007.003-.016 0-.022.005-.004.003-.006.007-.007.009zM10.476 11.795c.026.002.044-.002.054-.011.002-.003-.001-.022-.002-.039h-.01l-.042.05zM5.923 9.219c.1.085.223.181.381.293l.062-.015a5.133 5.133 0 01-.425-.33l-.018.052zM5.665 8.885c-.002.005-.002.011-.002.018 0 .008 0 .018.003.027l.004.007.026-.061c-.01.004-.026.003-.031.009z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M9.768 11.549c-.067-.031-.135-.062-.209-.098l-.011.013c.068.033.13.061.192.09l.028-.005zM10.53 11.794l-.001-.009c-.01.01-.028.013-.054.011l-.016.02a.302.302 0 00.04.003c.013 0 .02-.01.03-.014-.002-.004-.002-.009.001-.011zM10.789 11.415l.001-.001c-.003.002-.015-.001-.019 0l-.012.019.01.002c.013 0 .02-.003.027-.007l-.004-.001a.01.01 0 01-.003-.012zM10.802 11.425l-.005.002.006-.001.002-.002.004-.008.003-.006-.004.007zM10.595 11.727v-.002l-.001.004zM5.892 8.401h-.001l-.033.059-.005.009v.003l.001-.002zM5.686 8.805l.013-.001-.005-.002-.009.004-.033.058-.001.006.032-.062zM5.941 9.167c.107.095.249.205.425.331l.024-.005a5.455 5.455 0 01-.443-.343.325.325 0 00-.006.017zM5.67 8.937l-.004-.007-.005-.009c-.002-.008.002-.012.002-.018 0-.006 0-.012.002-.018l-.003.001c-.003.003-.008.004-.011.001l-.001-.004c-.004.013-.009.026-.005.042.002.009.013.023.018.034l.007-.022zM5.917 9.235c.097.083.215.175.366.283l.02-.005a5.46 5.46 0 01-.38-.294l-.006.016zM5.876 8.504c0-.008-.01-.019-.008-.026-.002.003-.006.006-.01.005-.003-.001-.004-.005-.004-.008-.004.014.006.033.01.051l.012-.022zM9.885 11.528a8.82 8.82 0 01-.283-.13l-.011.013c.094.045.18.084.265.121a.289.289 0 00.029-.004zM10.517 11.745h.01c0-.005.001-.005-.001-.011l-.009.011z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M10.432 8.683a5.59 5.59 0 01-.431.097v.159c.205-.038.377-.077.507-.115-.025-.047-.047-.096-.076-.141zM10.516 8.839a5.03 5.03 0 01-.515.116v.051c.213-.041.398-.084.538-.123a.61.61 0 00-.023-.044zM10.751 8.549c-.005-.005-.015-.009-.02-.013l.01.018.01-.005zM10.398 8.62c-.104.032-.24.064-.397.093v.05c.167-.032.312-.064.423-.094-.009-.016-.015-.034-.026-.049zM10.84 8.78l.024-.011c-.011-.007-.029-.014-.041-.02l.017.031z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M10.887 8.771v-.002.003zM10.76 8.555l-.009-.006-.01.005.008.013.02-.01-.002.001a.024.024 0 01-.007-.003zM10.864 8.769l-.024.011.007.013c.01-.005.029-.013.033-.017l-.004-.001-.012-.006zM10.772 8.549v.002zM10.539 8.882c-.14.039-.325.082-.538.123v.017c.212-.041.401-.084.546-.125l-.008-.015zM10.424 8.669a5.203 5.203 0 01-.423.094v.017c.17-.032.318-.065.431-.097l-.008-.014zM10.389 8.605a3.597 3.597 0 01-.388.091v.017c.157-.029.293-.061.397-.093l-.009-.015zM10.508 8.824a5.3 5.3 0 01-.507.115v.017c.211-.038.386-.078.515-.116l-.008-.016z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M10.789 10.265l.012-.105.005-.053a6.843 6.843 0 01-.774.168l-.031.003v.04c0 .042-.009.082-.012.123l.031-.003c.242-.034.535-.102.769-.173zM5.805 10.257c.296.09.643.156.8.182-.003-.038-.011-.074-.012-.112v-.051a5.658 5.658 0 01-.804-.179c.002.054.01.106.016.16z"
        }
      }),
      _c("path", { attrs: { d: "M11.133 10.09l-.001-.014v.014z" } }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M10.781 10.34c.003-.019.004-.039.006-.058a5.55 5.55 0 01-.765.172l-.035.004a1.99 1.99 0 01-.003.026.428.428 0 01.026.019l.019-.002c.287-.046.55-.104.752-.161zM11.142 9.95l-.01-.008v.013zM5.787 10.079c.194.061.465.128.806.18v-.048a6.827 6.827 0 01-.811-.185c0 .018.004.035.005.053zM5.447 10.192l.03.013-.004-.037c-.007.008-.023.016-.026.024zM5.45 9.951v-.005l-.003.003zM10.808 10.089l.006-.057a5.428 5.428 0 01-.791.18l-.021.002v.048l.028-.003c.302-.049.573-.11.778-.17zM5.812 10.329c.196.06.465.126.8.175l-.005-.049a7.128 7.128 0 01-.8-.181.489.489 0 00.005.055zM11.111 10.21c.008-.006.026-.012.031-.018-.006-.007-.02-.013-.028-.02 0 .013-.002.025-.003.038z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M10.779 10.358l.002-.018a6.816 6.816 0 01-.752.161l-.019.002.02.014h.002c.286-.046.547-.102.747-.159zM11.142 10.192c-.005.005-.023.012-.031.018a.123.123 0 01-.002.019c.015-.01.041-.02.049-.029-.003 0-.006 0-.008-.002l-.008-.006zM11.142 9.95l-.01.006v.017c.006-.005.021-.01.026-.015-.003 0-.006 0-.008-.002-.002-.003-.006-.004-.008-.006zM11.164 10.191v-.068.069zM11.163 10.197l.001-.004-.004.005zM11.163 9.954l.001-.003-.003.005zM11.165 9.949v-.068.068zM5.431 10.108l-.002.003.003-.003zM5.782 10.026c.296.092.647.158.811.185v-.017a6.75 6.75 0 01-.813-.186l.002.018zM5.431 9.866l-.001.002.002-.002zM10.806 10.107l.002-.018c-.205.06-.476.121-.779.17l-.028.003v.016l.031-.003c.301-.049.571-.109.774-.168zM5.806 10.275c.298.09.645.155.8.181l-.002-.017a6.933 6.933 0 01-.8-.182l.002.018zM10.814 10.032l.002-.017a5.697 5.697 0 01-.795.182l-.019.002v.016l.021-.002c.248-.037.552-.108.791-.181zM5.476 10.205l-.03-.013-.005.004c-.001.003-.004.005-.008.005h-.002c-.004-.001-.006-.004-.006-.008v.001c0 .003.002.006.004.007l.048.022a.055.055 0 00-.001-.018zM5.45 9.951a.008.008 0 01-.004-.002c0 .002-.003.003-.004.005-.001.003-.004.005-.008.005h-.002c-.003-.001-.005-.004-.005-.008v.001c0 .003.002.006.004.007a.39.39 0 00.02.009v-.017zM5.813 10.347c.204.061.476.127.8.175l-.002-.017a5.586 5.586 0 01-.8-.175.088.088 0 01.002.017zM10.787 10.282l.002-.017a5.656 5.656 0 01-.769.173l-.031.003-.002.017.035-.004c.24-.034.531-.101.765-.172zM5.789 10.096c.202.062.474.13.804.179v-.017a5.485 5.485 0 01-.806-.18l.002.018z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M10.139 11.705c.05-.054.094-.111.139-.169-.178.04-.384.08-.615.112l-.159.022-.224.031c-.116.083-.24.15-.372.201.31-.026.589-.065.797-.102.173-.034.316-.066.434-.095zM6.367 11.595l.055.067c.364.096.76.165 1.187.206a1.71 1.71 0 01-.302-.178 9.085 9.085 0 01-.994-.167c.017.025.036.049.054.072zM6.439 11.683l.016.019c.123.031.249.055.375.08-.137-.027-.261-.065-.391-.099zM7.703 11.906c-.019-.007-.04-.011-.059-.019-.147-.014-.303-.02-.443-.04.167.024.335.046.502.059zM5.799 11.375v-.002l-.001.001zM5.951 11.598a.541.541 0 00-.018-.025c-.003.005-.012.01-.014.015.01.004.023.006.032.01z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M6.299 11.505c.264.061.594.12.985.167a1.407 1.407 0 01-.074-.061c-.31-.041-.64-.11-.97-.184.017.026.04.052.059.078zM9.654 11.585l-.118.016-.159.021c-.024.02-.048.042-.073.06l.198-.027.159-.022c.238-.033.451-.074.633-.116.009-.011.019-.021.027-.033l-.026-.022a8.714 8.714 0 01-.641.123zM6.83 11.782c-.126-.024-.252-.048-.375-.08.022.023.038.05.06.073a8.22 8.22 0 001.407.198 1.677 1.677 0 01-.219-.067 9.406 9.406 0 01-.502-.059 6.81 6.81 0 01-.371-.065zM9.727 11.862c.079-.013.204-.04.339-.072l.009-.008c.018-.018.03-.039.047-.057-.114.028-.25.058-.414.091-.224.04-.531.083-.871.108-.065.022-.13.046-.198.06a7.55 7.55 0 001.088-.122z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M10.039 11.812c.009-.008.019-.014.027-.023a7.552 7.552 0 01-1.426.194c-.059.012-.121.014-.182.02a7.765 7.765 0 001.581-.191zM5.748 11.313v.002l.002-.003zM5.875 11.522l-.005.009.007-.009zM6.239 11.427c.33.073.66.143.97.184l-.022-.018a11.935 11.935 0 01-.963-.185c.005.006.011.012.015.019zM9.856 11.533l-.088.016-.028.005-.089.016-.118.016-.133.018-.023.019.159-.021.118-.016a9.25 9.25 0 00.641-.122l-.015-.013a8.7 8.7 0 01-.424.082zM9.663 11.648c.231-.032.437-.072.615-.112l.016-.019a8.102 8.102 0 01-.633.116l-.159.022c-.066.01-.131.019-.198.027l-.023.019.224-.031.158-.022zM6.439 11.683c.129.034.253.072.391.099.122.024.243.047.371.065.14.02.296.026.443.04-.012-.005-.023-.013-.035-.019a7.36 7.36 0 01-1.187-.206l.017.021zM5.951 11.598c-.009-.004-.022-.006-.031-.01l-.003.003a.008.008 0 01-.007.005h-.001c-.003 0-.005-.001-.007-.004l-.032-.053.034.058c.001.001.002.003.004.003.017.007.046.015.064.023-.007-.009-.015-.016-.021-.025zM5.799 11.375h-.002c0 .002-.004.004-.004.005 0 .003-.003.006-.006.007h-.002c-.002 0-.005-.001-.006-.004.001.002.002.003.004.003l.028.008-.012-.019zM10.122 11.725l.017-.02a9.41 9.41 0 01-.433.095 8.544 8.544 0 01-.797.102c-.023.009-.047.014-.071.021.34-.025.647-.068.871-.108a9.06 9.06 0 00.413-.09zM6.313 11.524c.268.061.598.121.994.167l-.023-.019a9.423 9.423 0 01-.985-.167.23.23 0 00.014.019zM6.515 11.775l.005.007.013.01c.396.097.902.174 1.492.201-.035-.006-.069-.011-.103-.019a8.221 8.221 0 01-1.407-.199z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M10.001 8.049v.014c.042.037.089.066.129.106.022.022.037.047.057.07.101.027.19.055.269.084-.07-.089-.135-.182-.217-.263a2.72 2.72 0 00-1.781-.795v.156a2.56 2.56 0 011.527.627h.016zM6.137 11.438a.882.882 0 00-.142.076 2.73 2.73 0 002.145 1.232v-.162a2.577 2.577 0 01-2.003-1.146zM6.125 8.333c.08-.031.171-.06.277-.088.023-.025.04-.053.063-.076.039-.039.086-.068.127-.105v-.02h.024a2.557 2.557 0 011.522-.623v-.156a2.734 2.734 0 00-1.788.794c-.084.085-.152.181-.225.274zM7.364 12.339l-.045-.018.045.018zM5.954 8.909a1.09 1.09 0 00-.162-.036c-.127.278-.2.576-.228.884.047-.026.101-.053.169-.08a2.52 2.52 0 01.221-.768zM10.864 9.69c.06.025.12.05.164.076a2.693 2.693 0 00-.326-1.072 2.578 2.578 0 00-.214-.07c.206.322.33.685.376 1.066zM10.67 11.046c.048.048.079.089.109.129.157-.329.246-.686.261-1.057a.942.942 0 00-.149-.085c-.003.354-.08.696-.221 1.013zM5.703 10.023a1.31 1.31 0 00-.154.075c.013.395.114.773.288 1.121.04-.026.09-.05.143-.074a2.545 2.545 0 01-.277-1.122zM10.131 11.838a2.574 2.574 0 01-1.673.747v.161a2.729 2.729 0 001.782-.794c.092-.092.167-.194.244-.296a1.093 1.093 0 00-.107-.118 2.705 2.705 0 01-.246.3z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M10.001 8.164v.003c.013.011.024.024.036.035l.015.003c-.015-.015-.034-.026-.051-.041zM8.821 7.542c-.044-.009-.089-.012-.133-.019.044.007.089.009.133.019zM11.114 9.833c-.008-.131-.014-.262-.04-.388.025.125.03.256.04.388-.001-.001-.001-.001 0 0zM10.97 10.906c-.021.061-.033.125-.057.184.025-.06.036-.124.057-.184zM10.801 10.16l-.012.105-.002.017c-.003.019-.003.039-.006.058l-.002.018a2.814 2.814 0 01-.174.626l.007.006c.112-.261.171-.541.189-.83zM10.914 8.925c.014.034.02.072.033.106-.013-.035-.019-.072-.033-.106zM5.477 10.164l-.005.004.004.037a2.8 2.8 0 00.299 1.077l.002-.003a2.807 2.807 0 01-.3-1.115zM6.053 11.117a.069.069 0 00.008-.003 2.575 2.575 0 01-.236-.646c.043.228.125.443.228.649zM7.178 7.762c.078-.038.155-.078.236-.109-.082.03-.159.069-.236.109zM7.606 7.594c.078-.023.154-.048.233-.064-.08.014-.155.041-.233.064zM6.842 7.96c.04-.028.077-.057.119-.082-.041.026-.08.054-.119.082zM5.814 9.649a.069.069 0 00.008-.003c.012-.073.015-.151.031-.221-.017.074-.028.149-.039.224zM5.699 8.876l-.004.001-.026.061c-.002.006-.003.014-.006.02-.109.27-.169.563-.189.867l.006-.005c.022-.333.092-.652.219-.944zM6.535 8.213l.006-.001.015-.017c-.006.007-.014.011-.021.018zM6.287 8.009a2.768 2.768 0 00-.305.369h.001a2.76 2.76 0 01.304-.369zM11.111 10.21l.004-.038-.001-.001c-.008.134-.014.269-.04.398.023-.111.026-.226.036-.34a.06.06 0 01.001-.019zM5.936 11.571l-.002.002a.541.541 0 00.018.025c.006.009.014.016.02.024a3.001 3.001 0 00-.036-.051zM6.367 11.595l-.054-.072a.23.23 0 01-.014-.019c-.019-.026-.042-.052-.059-.078-.004-.007-.01-.013-.015-.019l-.003-.004-.01.004c.045.067.103.126.155.188zM9.067 7.617c.094.032.189.063.28.106a2.555 2.555 0 00-.28-.106zM10.705 9.303a3.788 3.788 0 01.078.353 2.611 2.611 0 00-.078-.353zM9.503 7.807zM9.857 11.962a2.613 2.613 0 01-1.399.544v.001a2.492 2.492 0 001.399-.545zM8.073 12.5zM7.047 12.175a3.729 3.729 0 01-.2-.124c.065.046.132.084.2.124zM7.319 12.321l.045.018c.057.023.118.035.177.054a3.02 3.02 0 01-.351-.141c.044.021.084.05.129.069zM5.874 9.358c.011-.043.03-.082.043-.124a.088.088 0 00.005-.015l.018-.052.006-.017c.02-.058.037-.12.061-.176a2.602 2.602 0 00-.133.384z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M10.488 8.334c.031.012.067.024.093.036a2.808 2.808 0 00-2.123-1.166v.045c.674.04 1.308.313 1.794.799.089.088.161.188.236.286zM5.98 11.522c-.017.012-.022.024-.033.036a2.81 2.81 0 002.192 1.25v-.045a2.748 2.748 0 01-2.159-1.241zM6.34 8.048a2.746 2.746 0 011.8-.799v-.046a2.81 2.81 0 00-2.132 1.17c.009 0 .013-.004.023-.003l.063-.025c.078-.102.153-.205.246-.297zM5.776 8.87a.334.334 0 00-.055 0 2.786 2.786 0 00-.223.932c.016-.012.027-.024.049-.037.027-.312.101-.613.229-.895zM11.046 9.78c.02.013.033.026.049.038a2.779 2.779 0 00-.297-1.082c-.024-.011-.043-.023-.072-.034.18.332.288.696.32 1.078zM5.534 10.112c-.018.013-.029.025-.042.038.021.401.125.776.297 1.116.013-.013.014-.026.033-.039a2.722 2.722 0 01-.288-1.115zM10.79 11.189c.009.013.025.029.032.041a2.79 2.79 0 00.276-1.07c-.012-.011-.028-.021-.042-.031-.017.373-.108.73-.266 1.06zM10.252 11.964a2.741 2.741 0 01-1.794.798v.045a2.802 2.802 0 002.064-1.094c-.004-.011-.018-.028-.028-.043-.077.101-.151.203-.242.294z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M10.476 11.795l.042-.051.009-.011c-.002-.008.003-.003-.001-.013 0-.002-.003-.005-.004-.006a2.802 2.802 0 01-2.064 1.094v.016a2.812 2.812 0 002.001-1.009l.017-.02zM10.84 8.78l-.017-.031-.025-.012c.168.33.271.694.297 1.082l.018.014c-.008-.131-.014-.262-.039-.388a2.744 2.744 0 00-.127-.413c-.013-.035-.019-.072-.033-.106-.019-.046-.045-.087-.067-.132l-.007-.014zM10.457 8.322l.031.012c-.075-.098-.147-.197-.236-.286a2.75 2.75 0 00-1.794-.799v.016c.67.04 1.299.311 1.783.794.081.082.146.174.216.263zM5.995 11.514l-.014.008a2.746 2.746 0 002.159 1.241v-.016a2.734 2.734 0 01-2.145-1.233zM5.792 8.873l-.016-.003a2.722 2.722 0 00-.229.895c.005-.002.013-.005.017-.008.028-.308.102-.606.228-.884z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M11.028 9.766l.018.014a2.703 2.703 0 00-.321-1.078l-.023-.008c.182.33.293.692.326 1.072zM5.549 10.099c-.007.005-.008.009-.015.014.015.393.116.769.288 1.115l.014-.007a2.718 2.718 0 01-.287-1.122zM10.779 11.175l.011.014c.158-.33.249-.687.266-1.06l-.015-.011a2.717 2.717 0 01-.262 1.057zM10.24 11.952a2.729 2.729 0 01-1.782.794v.016a2.751 2.751 0 001.794-.798c.091-.091.165-.193.241-.293l-.009-.014c-.077.101-.152.204-.244.295zM6.008 8.373a2.81 2.81 0 012.131-1.17v-.016a2.821 2.821 0 00-1.852.822 2.816 2.816 0 00-.304.368c.009 0 .014-.004.025-.004zM8.139 12.808a2.812 2.812 0 01-2.192-1.25c-.004.004-.009.008-.012.013.104.156.222.303.354.435.478.48 1.13.778 1.849.819v-.017z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M11.113 10.171l-.015-.011a2.785 2.785 0 01-.276 1.07l.009.017c.026-.053.059-.103.082-.158.024-.059.037-.123.057-.184.038-.111.08-.22.103-.337.026-.128.033-.263.04-.397zM8.458 7.204a2.804 2.804 0 012.123 1.166c.016.007.024.014.039.021a2.827 2.827 0 00-2.162-1.203v.016zM6.094 8.345l.031-.012c.073-.093.141-.189.226-.274a2.73 2.73 0 011.788-.794v-.016a2.738 2.738 0 00-1.799.799c-.093.092-.168.195-.246.297zM5.721 8.87c-.009.001-.015.004-.022.006a2.827 2.827 0 00-.219.944l.018-.018c.024-.329.095-.644.223-.932zM5.492 10.15l-.015.014c.023.401.128.776.3 1.116a.127.127 0 01.011-.013 2.8 2.8 0 01-.296-1.117z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M10.001 8.084v.059c.027.025.059.044.085.07l.001.001.073.017c-.015-.016-.026-.035-.041-.05-.036-.037-.08-.063-.118-.097zM6.429 8.238l.074-.018.006-.008c.026-.026.057-.044.083-.069v-.058c-.037.034-.079.06-.115.095-.018.018-.03.04-.048.058zM6.509 11.794a2.559 2.559 0 01-.313-.38l-.044.018a2.56 2.56 0 001.987 1.137v-.046a2.52 2.52 0 01-1.63-.729zM6.714 8.045a2.494 2.494 0 011.425-.561v-.046a2.537 2.537 0 00-1.497.607h.072zM9.887 8.048h.072a2.536 2.536 0 00-1.501-.61v.046a2.493 2.493 0 011.429.564zM6.013 8.929a.746.746 0 00-.044-.014 2.552 2.552 0 00-.219.755l.047-.015c.036-.254.107-.497.216-.726zM5.763 10.003l.001-.007c-.017.007-.029.014-.045.02.002.397.103.776.276 1.123l.043-.016a2.498 2.498 0 01-.275-1.12zM10.799 9.661l.048.021a2.527 2.527 0 00-.38-1.064l-.06-.016c.213.318.34.68.392 1.059zM10.623 11.002l.034.032a2.56 2.56 0 00.219-1.008 1.99 1.99 0 00-.044-.018c0 .348-.074.683-.209.994zM10.087 11.794a2.508 2.508 0 01-1.629.729v.046a2.558 2.558 0 001.661-.742c.093-.093.17-.196.246-.299l-.032-.032a2.758 2.758 0 01-.246.298z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M10.815 10.014l-.002.017c0 .019-.005.038-.006.057l-.002.018-.005.053a2.474 2.474 0 01-.19.831.12.12 0 00.012.011c.135-.311.208-.646.209-.993l-.016-.006v.001c.002.004 0 .008 0 .011zM10.398 8.62c.01.016.016.033.026.049l.008.014c.028.045.05.094.076.141l.008.015.023.044.008.015c.065.131.116.266.157.406.034.116.061.232.077.353l.017.005a2.501 2.501 0 00-.392-1.059.183.183 0 00-.025-.008l.008.01.009.015zM10.278 11.536c-.045.057-.089.115-.139.169l-.017.02c-.017.018-.029.039-.047.057l-.009.008c-.008.008-.019.014-.027.023-.057.055-.121.101-.182.15a2.478 2.478 0 01-1.399.545v.016a2.51 2.51 0 001.629-.729c.093-.093.17-.195.246-.299l-.012-.011-.027.033a.259.259 0 00-.016.018zM10.001 8.063v.021c.038.034.081.06.118.097.016.016.026.034.041.05l.028.008c-.021-.022-.036-.048-.057-.07-.04-.04-.088-.069-.13-.106zM6.403 8.245l.026-.007c.017-.018.03-.04.048-.058.036-.036.078-.062.116-.095v-.021c-.042.037-.088.065-.128.105-.023.023-.04.051-.062.076zM6.642 8.045a2.547 2.547 0 011.497-.607v-.016a2.555 2.555 0 00-1.522.622l.025.001zM8.821 7.542c.084.018.164.049.246.075.096.031.19.064.281.106.053.025.104.055.155.083.098.054.193.113.284.18.026.019.049.041.074.061h.026a2.5 2.5 0 00-1.429-.565v.016c.077.005.155.011.231.023.043.009.088.012.132.021zM5.854 9.426c.005-.023.014-.045.021-.067.035-.132.076-.261.133-.385.006-.014.015-.026.021-.04a.098.098 0 00-.016-.005c-.109.229-.18.472-.216.726a.11.11 0 01.017-.005c.011-.076.022-.151.04-.224zM7.722 12.448c-.062-.015-.121-.036-.181-.055-.059-.019-.12-.031-.177-.054l-.045-.018c-.045-.019-.085-.047-.129-.069a2.45 2.45 0 01-.143-.077 2.453 2.453 0 01-.514-.382l-.013-.01-.005-.007c-.023-.023-.039-.05-.06-.073l-.016-.019-.017-.02-.055-.067c-.052-.063-.11-.122-.155-.188a.197.197 0 00-.016.007 2.51 2.51 0 001.943 1.109v-.016l-.066-.006a3.128 3.128 0 01-.351-.055zM5.825 10.469c-.008-.04-.006-.081-.012-.122l-.002-.018-.005-.054-.002-.018c-.005-.054-.014-.107-.016-.161l-.002-.017c-.001-.018-.005-.035-.005-.053l-.002-.018v-.004l.001-.015-.016.007-.001.007c0 .396.102.774.275 1.12l.015-.006a2.486 2.486 0 01-.228-.648zM10.001 8.143v.021c.016.015.035.026.051.042l.035.008-.001-.001c-.026-.027-.057-.045-.085-.07z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M9.984 8.049a2.554 2.554 0 00-1.526-.627v.016a2.546 2.546 0 011.501.61l.025.001zM6.152 11.432l-.015.006a2.593 2.593 0 002.003 1.146v-.016a2.555 2.555 0 01-1.662-.743 2.53 2.53 0 01-.326-.393zM6.509 8.213l-.006.008.032-.008c.007-.007.015-.011.021-.018.011-.011.025-.019.036-.03v-.021c-.026.025-.057.043-.083.069zM5.969 8.914a.088.088 0 01-.015-.005c-.114.242-.186.5-.221.768l.017-.007c.035-.264.107-.517.219-.756zM10.847 9.682l.017.008a2.547 2.547 0 00-.375-1.066l-.022-.006c.208.321.332.684.38 1.064zM10.658 11.034l.012.011a2.57 2.57 0 00.222-1.013l-.016-.006a2.541 2.541 0 01-.218 1.008zM5.719 10.016l-.016.007c.003.397.104.776.277 1.123l.015-.007a2.538 2.538 0 01-.276-1.123zM10.119 11.826a2.558 2.558 0 01-1.661.742v.016a2.574 2.574 0 001.673-.747c.093-.093.169-.196.246-.299a.13.13 0 01-.011-.012 2.606 2.606 0 01-.247.3zM6.714 8.045h.026c.034-.028.066-.059.102-.085.039-.028.078-.056.119-.082.07-.044.144-.08.217-.117.078-.039.155-.078.236-.109.063-.024.128-.04.193-.059.077-.022.152-.049.232-.063.098-.018.2-.023.3-.03v-.016a2.49 2.49 0 00-1.425.561z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M8.294 12.02c-.026 0-.051-.006-.077-.008v.827h.163v-.827c-.029.001-.057.008-.086.008zM8.217 8.047l.001-.871h.162l-.001.87z"
        }
      }),
      _c("path", {
        attrs: {
          d: "M8.218 7.176h.162V7.16h-.162zM8.38 12.839h-.162v.016h.162z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M8.396 12.01v.862h.045v-.866l-.045.004zM8.155 7.144h.046v.903h-.046zM8.396 7.143h.045v.903h-.045zM8.155 12.006v.866h.046v-.861l-.046-.005z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M8.458 12.808v-.802a.088.088 0 00-.016.002v.866h-.046v-.862a.088.088 0 00-.016.002v.868c0 .005.004.008.008.008h.062l.006-.002c.002-.001.002-.004.002-.006v-.074zM8.139 7.203v.843h.016v-.902h.046v.903h.016v-.912a.008.008 0 00-.008-.008h-.062a.008.008 0 00-.008.008v.068zM8.38 7.176v.871h.016v-.903h.045v.903h.016V7.135a.008.008 0 00-.008-.008h-.061l-.006.002c-.002.001-.002.004-.002.006v.041zM8.218 12.839v-.827a.088.088 0 01-.016-.002v.861h-.047v-.866a.088.088 0 01-.016-.002V12.877c0 .005.004.008.008.008h.062l.006-.002c.002-.001.002-.004.002-.006v-.038z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M10.127 9.723c.506.101.839.223.989.354V9.93c-.189-.182-.7-.31-1.003-.371-.034-.007-.076-.009-.111-.015v.162c.039.007.086.01.125.017zM6.593 9.543c-.046.008-.101.011-.146.02-.422.08-.884.232-.98.368v.144c.104-.112.478-.252.964-.349.049-.01.111-.013.162-.022v-.161z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M11.132 9.955v-.013l-.016-.012v.147c.005.004.012.008.016.013v-.135zM5.467 10.074v-.143c-.004.005-.014.01-.017.015v.144l.017-.016z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M10.001 9.528c.036.006.079.009.114.016.311.062.851.194 1.033.385V9.88c-.123-.141-.477-.273-1.024-.382-.038-.007-.084-.01-.123-.017v.047zM10.001 9.77c.036.006.079.009.114.016.311.062.851.194 1.033.385v-.049c-.123-.141-.477-.273-1.024-.382-.038-.007-.084-.01-.123-.017v.047zM6.593 9.719c-.05.009-.11.012-.159.022-.448.09-.947.252-.992.376v.045c.12-.162.674-.309.998-.374.047-.008.105-.011.153-.02v-.049zM6.593 9.477c-.05.009-.11.012-.158.022-.577.112-.956.279-.992.376v.045c.114-.155.649-.306 1.001-.373.046-.009.102-.012.149-.021v-.049z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M5.434 10.201c.003 0 .006-.002.008-.005l.005-.004c.004-.008.02-.016.026-.024a.022.022 0 01.005-.004l.015-.014c.013-.013.023-.025.042-.038.007-.005.008-.009.015-.014.041-.026.096-.05.154-.075l.016-.007c.016-.007.028-.014.045-.02l.016-.008c.191-.072.434-.138.662-.183.046-.009.102-.012.15-.021v-.016c-.048.009-.106.012-.153.021-.324.064-.878.212-.998.374v-.045c.045-.125.544-.287.992-.376.048-.009.108-.013.159-.022v-.017c-.051.009-.112.013-.162.022-.486.097-.86.237-.964.349l-.017.016c-.004.006-.016.012-.018.018l-.003.003-.003.003v.08c0 .004.003.007.006.008l.002-.001zM5.434 9.959c.003 0 .006-.002.008-.005l.005-.004.004-.003c.003-.005.013-.01.016-.015.096-.135.558-.288.98-.368.045-.009.1-.012.146-.02v-.018c-.047.009-.104.012-.149.021-.352.067-.887.217-1.001.373v-.045c.036-.097.416-.264.992-.376.048-.009.108-.013.158-.022v-.016c-.051.008-.112.012-.161.022l-.042.01-.024.005-.062.015-.021.004a4.349 4.349 0 00-.461.129l-.008.003a.325.325 0 01-.017.006l-.047.015-.017.007a1.516 1.516 0 00-.169.08c-.004.003-.012.006-.017.008-.022.013-.033.025-.049.037-.008.006-.012.012-.018.018l-.006.005c-.013.014-.036.028-.042.041l-.003.003-.003.003v.08c0 .004.003.007.006.008l.002-.001zM11.095 9.818c-.016-.013-.029-.026-.049-.038l-.018-.014a1.423 1.423 0 00-.164-.076l-.017-.008-.048-.021-.017-.005-.002-.001a4.589 4.589 0 00-.653-.174c-.039-.008-.086-.01-.126-.017v.016c.039.007.085.01.123.017.547.109.901.242 1.024.382v.049c-.182-.191-.721-.323-1.033-.385-.035-.007-.078-.009-.114-.016v.017c.035.006.077.009.111.015.303.061.815.189 1.003.371l.016.012c.002.003.008.005.01.007l.008.006a.008.008 0 00.008.002h.001l.002-.002a.005.005 0 00.003-.005V9.876a.008.008 0 00-.002-.005c-.011-.013-.034-.026-.049-.038l-.001-.001c-.004-.005-.01-.009-.016-.014zM11.116 10.077c-.15-.13-.483-.252-.989-.354-.039-.008-.086-.01-.126-.017v.016c.039.007.085.01.123.017.547.109.901.242 1.024.382v.049c-.182-.191-.722-.323-1.033-.385-.035-.007-.078-.009-.114-.016v.017c.035.006.076.009.111.015.196.039.475.109.704.2l.016.006.044.018.016.006a.942.942 0 01.149.085l.015.011c.014.01.03.02.042.031l.015.011.001.001c.007.007.021.013.028.02l.008.006a.008.008 0 00.008.002h.001l.002-.002.004-.005V10.115a.008.008 0 00-.002-.005c-.007-.008-.021-.015-.03-.023l-.001-.001a.053.053 0 01-.016-.009z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M10.775 8.645l-.075-.13c-.137-.096-.422-.18-.699-.238v.151c.344.068.647.154.774.217zM6.593 8.278c-.17.036-.319.076-.439.117.072.016.154.04.247.073.064-.015.122-.032.192-.045v-.145z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M10.741 8.553l-.01-.018c-.008-.007-.021-.013-.031-.02l.075.13.028.015-.055-.094-.007-.013z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M6.593 8.439c-.06.011-.108.026-.164.039.027.01.05.016.078.027l.086-.019v-.047zM6.593 8.263v-.048a2.952 2.952 0 00-.533.161c.021.002.048.01.072.015.125-.046.277-.088.461-.128zM10.001 8.26c.284.059.591.146.728.246l-.036-.057c-.104-.077-.375-.168-.692-.238v.049zM10.001 8.492c.402.08.71.17.857.253l-.03-.053c-.053-.058-.424-.168-.827-.247v.047z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M6.593 8.487l-.086.019c.01.004.019.006.029.011.019-.004.036-.009.056-.012v-.018zM10.581 8.369c-.026-.012-.062-.024-.093-.036a3.234 3.234 0 00-.3-.096l-.028-.008-.073-.017-.035-.008-.015-.003-.036-.008v.017c.317.07.588.161.692.238l.036.057c-.137-.1-.444-.187-.728-.246v.017c.277.058.562.142.699.238.01.007.023.013.031.02.005.005.016.009.02.013l.009.006.006.003.002-.001.003-.001c.002-.001 0-.003.001-.005v-.002c0-.001.002-.003.001-.004l-.066-.105a.002.002 0 00-.002-.002c-.02-.015-.054-.031-.085-.047-.015-.006-.023-.013-.039-.02zM6.593 8.278v-.015c-.184.04-.336.082-.461.127l.022.004c.12-.041.269-.08.439-.116zM10.775 8.645c-.128-.064-.43-.15-.774-.217v.017c.403.079.774.189.827.247l.03.053c-.147-.083-.455-.173-.857-.253v.017c.14.028.266.057.379.087l.026.007.06.016.022.006c.081.023.152.047.214.07l.023.008c.029.012.049.023.072.034a.592.592 0 01.025.012c.013.007.031.014.041.02l.012.006.004.001h.001l.006-.002v-.002-.003c0-.002.002-.004.001-.005l-.046-.082c-.005-.006-.027-.014-.038-.021a.556.556 0 00-.028-.016zM6.593 8.423c-.07.013-.128.03-.192.045a.23.23 0 01.028.01c.055-.013.104-.027.164-.039v-.016zM6.593 8.216v-.017l-.052.012-.006.001-.032.009-.074.018a2.64 2.64 0 00-.304.094l-.031.012c-.02.008-.045.016-.063.025.008 0 .021.005.029.006.132-.058.311-.112.533-.16z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M6.75 11.016c-.084.017-.17.026-.253.047-.048.012-.1.022-.147.036-.242.071-.496.178-.541.26l.085.138c.055-.066.227-.161.506-.239.064-.018.126-.021.189-.036.081-.02.162-.041.242-.057a1.522 1.522 0 01-.081-.149z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M5.894 11.498l-.085-.138c-.002.004-.01.009-.011.014l.001.001.012.02.072.118c.003-.006.007-.01.011-.015z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M6.589 11.222c.083-.02.165-.031.247-.047l-.005-.009c-.08.015-.161.037-.242.056zM6.744 11.004c-.085.017-.165.039-.246.059.082-.021.169-.031.253-.047a.047.047 0 01-.007-.012zM6.844 11.189c-.146.028-.291.042-.44.084-.335.094-.506.209-.519.259l.024.039c.054-.095.334-.204.507-.252.138-.039.301-.059.452-.088-.01-.012-.015-.028-.024-.042z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M6.721 10.957c-.078.016-.159.025-.236.044-.049.013-.101.022-.149.036-.34.099-.565.209-.575.281l.023.041c.057-.124.509-.259.562-.274.124-.036.255-.067.39-.094l-.015-.034z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M5.787 11.386c.003-.001.006-.003.006-.007 0-.002.004-.004.004-.005l.001-.001c.001-.004.008-.009.011-.014.045-.082.299-.19.541-.26.047-.014.099-.023.147-.036.081-.021.161-.042.246-.059l-.007-.014a4.737 4.737 0 00-.39.094c-.054.016-.506.151-.563.275l-.023-.041c.01-.072.235-.182.575-.281.047-.014.1-.023.149-.036.076-.02.152-.04.233-.056l-.005-.015a3.847 3.847 0 00-.659.187l-.015.006-.043.016-.015.007a.949.949 0 00-.143.074l-.014.007c-.019.013-.02.026-.033.039l-.011.013-.002.003c-.007.01-.023.02-.025.03l-.003.003-.003.004.001.005.033.059h.001c.001.002.004.004.006.004v-.001zM5.909 11.597c.001 0 .001 0 0 0a.01.01 0 00.008-.005l.003-.003c.002-.005.01-.01.014-.015l.002-.002.012-.013c.011-.012.016-.024.033-.036l.014-.008c.039-.026.087-.051.142-.076l.015-.006a1.99 1.99 0 01.06-.025l.01-.004a2.34 2.34 0 01.198-.068c.139-.04.303-.06.456-.089l-.008-.014c-.151.029-.315.048-.452.088-.173.048-.453.156-.507.252l-.024-.039c.014-.05.185-.165.519-.259.149-.043.294-.056.44-.084l-.008-.014c-.082.016-.165.027-.247.047-.064.014-.125.016-.189.035-.279.078-.45.173-.506.239l-.01.014-.007.01c-.001.003-.006.007-.007.009l-.001.002.001.005.033.055c.001.003.004.004.006.004z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M9.852 11.006c.404.295.683.538.733.663l.001.001.202-.313c-.018-.15-.374-.453-.812-.774a1.702 1.702 0 01-.124.423zM6.593 8.632c-.269-.111-.491-.187-.609-.189h-.006c-.015 0-.037.01-.058.015l-.184.341h.001c.126-.018.433.081.856.271v-.438z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M10.77 11.414l.026-.04v-.001c0-.004-.008-.012-.008-.016l-.202.313-.001-.001c.002.005.009.012.01.017l.163-.253.012-.019zM5.736 8.799l.184-.341c-.008.002-.014.002-.022.005l-.022.04-.012.023-.147.274v.002c.005-.002.013-.002.019-.003z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M6.593 9.089c-.471-.214-.812-.323-.896-.271l-.021.039a.178.178 0 01.056-.007c.145 0 .457.109.861.293v-.054zM9.977 10.563c.456.332.838.656.835.81v.007l.022-.033c.054-.109-.284-.431-.851-.844l-.006.06zM6.593 8.559c-.369-.152-.608-.209-.685-.153l-.02.036a.226.226 0 01.09-.015h.006c.118.002.34.078.608.188v-.056zM9.822 11.063c.431.319.69.555.719.652a.152.152 0 01.012.054l.026-.041c.003-.005.002-.012.002-.019l-.001-.005c0-.006-.002-.012-.004-.019-.037-.117-.324-.364-.733-.663-.006.014-.015.027-.021.041z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M5.661 8.886l.003-.001c.006-.006.022-.005.032-.008l.004-.001c.006-.002.012-.005.021-.006a.334.334 0 01.055 0l.017.003c.044.006.096.017.161.036l.016.005.044.014.016.005c.149.049.338.125.564.227v-.017c-.406-.184-.717-.293-.862-.293a.145.145 0 00-.055.008l.021-.039c.084-.052.425.057.896.271v-.02c-.424-.19-.731-.289-.858-.271-.006.001-.014.001-.02.003-.005.001-.013 0-.017.002-.003.001-.011 0-.013.002l-.003.002-.032.062-.003.007c-.001.002 0 .004.002.007l.001.004a.008.008 0 00.01-.002zM5.868 8.478s.001 0 0 0l.008-.01c.006-.005.014-.002.022-.005.008-.003.014-.003.022-.005.021-.005.044-.015.058-.015h.006c.117.002.34.078.608.189v-.017c-.268-.11-.49-.186-.608-.188h-.006a.226.226 0 00-.09.015l.02-.036c.077-.056.316.001.685.153V8.54l-.057-.024c-.01-.004-.019-.006-.029-.011-.028-.011-.051-.017-.078-.027a2.276 2.276 0 00-.297-.088c-.024-.005-.051-.012-.072-.014-.008-.001-.021-.006-.029-.006-.01-.001-.014.003-.023.003-.01 0-.016.004-.025.005h-.001c-.032.002-.067.002-.085.015l-.003.003-.002.005-.038.069-.001.002v.001l.001.002c0 .003.002.007.005.008s.007-.002.009-.005zM10.822 11.23c-.007-.012-.023-.028-.032-.041l-.011-.014a1.012 1.012 0 00-.109-.129l-.012-.011-.034-.032-.012-.011-.007-.006a6.204 6.204 0 00-.594-.48l-.026-.019-.002.018c.567.413.905.735.851.844l-.022.033v-.007c.003-.154-.379-.477-.835-.81l-.002.019c.438.32.795.624.812.774.001.005.008.012.008.016V11.384c0 .014 0 .02-.003.026l-.004.006-.001.001c-.002.004-.001.009.002.011l.004.001h.001l.002-.001a.008.008 0 00.005-.002l.005-.008.005-.007.036-.055v-.001c.013-.026.005-.063-.017-.107-.002-.006-.004-.012-.008-.018zM10.585 11.669c-.05-.125-.329-.368-.733-.663l-.008.015c.409.299.696.547.733.663.001.003.006.008.006.01l-.001.005c.001.004-.001.006-.001.009 0 .007.001.014-.002.019l-.026.041a.152.152 0 00-.012-.054c-.029-.097-.288-.333-.719-.652l-.008.015c.194.143.349.268.467.371l.015.013.026.022a.063.063 0 01.012.011l.032.032.011.012c.047.046.083.085.107.118l.009.014c.01.015.024.032.028.043l.004.006c.004.01-.001.006.001.013l.001.011c.001.017.004.036.002.039l.001.009c-.003.002-.003.007-.001.01v.001a.01.01 0 00.007.003c.002 0 .003 0 .005-.002l.016-.013.002-.002.035-.055.001-.008.001-.005c.003-.01.007-.02.004-.033 0-.002-.003-.005-.004-.006-.002 0-.009-.007-.011-.012z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FFF",
          d:
            "M7.617 11.003a.952.952 0 001.356.004.943.943 0 00.283-.678l.001-.148V8.793L7.332 8.79v1.535a.968.968 0 00.285.678zm-.123-.931l.001-.307h.428v.307a.235.235 0 01-.063.162.205.205 0 01-.151.068.205.205 0 01-.151-.068.238.238 0 01-.064-.162zm1.023 0a.235.235 0 01-.063.162.205.205 0 01-.151.068.205.205 0 01-.151-.068.237.237 0 01-.063-.162l.001-.307h.428v.307zm0 .736a.235.235 0 01-.063.162.205.205 0 01-.151.068.205.205 0 01-.151-.068.237.237 0 01-.063-.162V10.5h.428v.308zm.592-.736a.235.235 0 01-.063.162.205.205 0 01-.151.068.205.205 0 01-.151-.068.237.237 0 01-.063-.162l.001-.307h.428v.307zm-1.021-.743l.001-.307h.428v.307a.235.235 0 01-.063.162.205.205 0 01-.151.068.205.205 0 01-.151-.068.232.232 0 01-.064-.162z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FFF",
          d:
            "M6.612 8.064v2.254c0 .446.176.866.495 1.185a1.674 1.674 0 002.38.005c.318-.317.493-.736.495-1.182V8.068l-3.37-.004zm3.313 2.259c0 .433-.17.841-.479 1.148a1.626 1.626 0 01-2.306-.002 1.61 1.61 0 01-.481-1.147l.007-.001v-.001h-.007l.002-2.198 3.264.001v2.2z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M8.218 8.046h-.079l-1.4-.002h-.146v2.283c0 .038.009.075.012.112l.002.017a.813.813 0 00.005.049l.002.017c.017.141.048.278.099.409l.005.015.004.012.015.033a.042.042 0 00.007.013l.007.012c.024.051.052.1.081.149l.005.009.008.014c.009.014.014.029.023.043l.008.014c.063.095.136.186.219.269.029.029.063.05.094.077l.022.018c.025.021.049.042.074.061l.023.019c.096.07.196.13.302.178.012.005.023.014.035.019.019.008.04.012.059.019.071.027.144.05.219.067.034.008.068.013.103.019.038.006.076.008.114.011l.016.002.046.005.016.002c.026.001.051.008.077.008.029 0 .057-.007.085-.008a.088.088 0 00.016-.002l.045-.004a.088.088 0 00.016-.002c.061-.006.123-.008.182-.02.068-.014.133-.038.198-.06.023-.008.048-.013.071-.021.132-.051.255-.119.372-.201l.023-.019c.025-.019.049-.04.073-.06a.211.211 0 00.023-.019c.033-.028.069-.051.101-.082.018-.018.031-.039.048-.058l.011-.013.032-.039.011-.013c.083-.1.154-.206.212-.32l.008-.015c.007-.014.016-.027.022-.041l.008-.015c.06-.135.1-.277.123-.424l.002-.019c.003-.02.004-.041.006-.061l.002-.018a1.99 1.99 0 01.003-.026l.002-.017c.003-.041.012-.081.012-.123V8.049H9.86l-1.402-.002H8.38l-.162-.001zm1.764.022v2.258a1.672 1.672 0 01-.495 1.182 1.676 1.676 0 01-2.38-.005 1.66 1.66 0 01-.495-1.185V8.064l3.37.004z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "red",
          d:
            "M6.673 10.322c0 .427.169.831.477 1.137a1.614 1.614 0 002.286.003c.305-.303.473-.705.475-1.132V8.137H6.675l-.002 2.183h-.007v.001l.007-.001v.002zm.622 1.193c-.012-.011-.013-.029-.003-.039l.001-.001-.103-.127a.022.022 0 01-.015.006.028.028 0 01-.02-.009c-.006-.005-.001-.012-.001-.019a.02.02 0 01-.015.006.032.032 0 01-.02-.008.027.027 0 01-.002-.037l.01-.01-.059-.063a.022.022 0 01-.015.006.02.02 0 01-.015-.006l-.046-.044.005-.005.005.005-.005-.005.029-.029.018.017.008-.008-.018-.018.035-.035.018.018.008-.008-.018-.018.035-.035.046.046c.009.009.008.021 0 .031l.063.058.012-.012-.119-.129-.001.001a.023.023 0 01-.017.007.02.02 0 01-.015-.006L7.034 11l.005-.005.005.005-.005-.005.03-.03.018.018.008-.008-.018-.018.035-.036.018.018.008-.008-.018-.018.035-.036.046.046c.004.004.006.01.006.015a.024.024 0 01-.007.016l-.002.002.13.118.012-.012L7.281 11a.022.022 0 01-.015.006.02.02 0 01-.015-.006l-.042-.042v-.006l.031-.031.018.017.008-.008-.018-.018.035-.035.017.018.008-.008-.019-.017.035-.035.046.045c.009.009.008.021 0 .031l.063.058.011-.011a.024.024 0 01.017-.007c.008.001.015.003.02.008.01.01.01.026.002.035.007 0 .013-.004.019.001a.028.028 0 01.009.02.02.02 0 01-.006.015l.129.101a.026.026 0 01.019-.007.034.034 0 01.019.009c.011.011.013.029.003.039l-.341.343a.023.023 0 01-.017.007.023.023 0 01-.022-.007zm2.252-.362l.018-.017.031.031v.006l-.042.042a.022.022 0 01-.015.006.022.022 0 01-.015-.006l-.059.063.01.01c.01.01.009.026-.002.037a.027.027 0 01-.02.008.025.025 0 01-.015-.006c0 .007.004.013-.001.019a.028.028 0 01-.02.009.02.02 0 01-.015-.006l-.103.127.001.001c.01.01.009.028-.003.039a.031.031 0 01-.022.009c-.006 0-.013-.002-.017-.007l-.341-.343c-.01-.01-.009-.028.003-.039a.028.028 0 01.019-.009.022.022 0 01.019.007l.129-.101a.025.025 0 01-.006-.015c0-.007.003-.015.009-.02a.025.025 0 01.018-.008h.001c-.004-.009-.007-.02.001-.029a.03.03 0 01.02-.008c.007 0 .013.002.017.007l.011.011.063-.058c-.008-.009-.009-.022 0-.031l.046-.046.035.035-.018.018.008.008.018-.018.035.035-.019.016.008.008.018-.017.032.032-.002.006L9.34 11a.022.022 0 01-.015.006A.022.022 0 019.31 11l-.06.063.012.012.13-.118-.002-.003c-.004-.005-.007-.01-.007-.016s.002-.011.007-.015l.046-.046.035.036-.018.017.008.008.018-.018.035.036-.018.018.008.008.018-.018.031.032.002.005-.044.044a.022.022 0 01-.015.006.023.023 0 01-.017-.007l-.001-.001-.119.129.012.012.063-.058c-.008-.009-.009-.022 0-.031l.046-.045.035.035-.018.018.008.008.018-.018.035.035-.018.018.007.007zm.135-1.601c0 .012-.011.022-.023.022h-.002l.008.176h.017l.003-.086a.022.022 0 01-.021-.022v-.065h.049v.026h.011v-.026h.049v.026h.011v-.025h.044l.005.003v.061c0 .011-.01.019-.022.021l.003.087h.014c.014 0 .025.012.025.027a.026.026 0 01-.024.026c.005.005.013.007.013.015a.026.026 0 01-.023.026l.018.163h.001c.014 0 .026.013.026.03 0 .016-.012.029-.026.029h-.484c-.014 0-.026-.013-.026-.029s.012-.029.025-.029l.019-.164a.028.028 0 01-.022-.027c0-.008.008-.009.013-.014a.026.026 0 01-.024-.026c0-.015.011-.027.025-.027h.015l.003-.086a.021.021 0 01-.022-.021v-.066h.049v.026h.011v-.026h.049v.026h.011v-.025h.044l.006.003v.061c0 .011-.01.019-.021.021l.003.087h.017l.008-.176h-.004c-.013 0-.023-.009-.023-.022v-.065h.05v.025h.011v-.025h.05v.025h.011v-.024h.044l.005.003.001.061zM9.51 8.165h.05v.025h.011v-.025h.05v.025h.011v-.025h.044l.005.003v.061c0 .012-.011.022-.023.022h-.001l.008.176h.017l.003-.086a.021.021 0 01-.022-.021v-.065h.049v.026h.011v-.026h.049v.026h.011v-.025h.044l.005.003v.061c0 .011-.01.019-.022.021l.003.087h.014c.014 0 .025.012.025.027a.026.026 0 01-.024.026c.005.005.013.007.013.015a.026.026 0 01-.023.026l.018.163h.001c.014 0 .026.013.026.029s-.012.029-.026.029h-.483c-.014 0-.026-.013-.026-.029s.012-.029.025-.029l.019-.164a.027.027 0 01-.022-.026c0-.008.008-.009.013-.014a.026.026 0 01-.024-.027c0-.015.011-.027.025-.027h.015l.003-.086a.021.021 0 01-.022-.021v-.065h.049v.026h.011v-.026h.049v.026h.011v-.025h.044l.006.003v.061c0 .011-.01.019-.021.021l.003.087h.017l.008-.176h-.004c-.013 0-.023-.009-.023-.022v-.065zm-1.236 0h.05v.025h.011v-.025h.05v.065c0 .013-.01.022-.023.022H8.36l.008.176h.017l.003-.088c-.012-.001-.022-.009-.022-.02v-.061l.005-.003H8.414v.025h.011v-.026h.049v.025h.011v-.025h.049v.065c0 .012-.01.021-.022.021l.003.086h.015c.014 0 .025.012.025.027a.026.026 0 01-.024.026c.005.005.013.006.013.014a.026.026 0 01-.023.026l.019.164c.014 0 .025.013.025.029s-.012.029-.026.029h-.482c-.014 0-.026-.013-.026-.029s.012-.029.026-.029h.001l.018-.164a.025.025 0 01-.023-.025c0-.008.008-.01.013-.015a.025.025 0 01-.023-.026c0-.015.011-.027.025-.027h.014l.003-.087c-.012-.001-.022-.009-.022-.02v-.061l.005-.003H8.111v.025h.011v-.026h.049v.025h.011v-.025h.049v.065c0 .012-.01.021-.022.021l.003.086h.017l.008-.176a.022.022 0 01-.023-.022v-.061l.005-.003H8.263v.025h.011v-.025zm-1.547.549c0-.016.011-.029.026-.029h.001l.018-.163a.028.028 0 01-.024-.027c0-.008.008-.01.013-.015a.025.025 0 01-.023-.026c0-.015.011-.027.025-.027h.014l.003-.087c-.012-.001-.022-.009-.022-.02v-.061l.005-.003H6.806v.025h.011v-.026h.049v.025h.011v-.025h.049v.065c0 .012-.01.021-.022.021l.003.086h.017l.008-.176a.022.022 0 01-.023-.022v-.061l.005-.003H6.958v.025h.011v-.025h.05v.025h.011v-.025h.05v.065c0 .013-.01.022-.023.022h-.002l.008.176h.017l.003-.088c-.012-.001-.022-.009-.022-.02v-.061l.005-.003H7.109v.025h.011v-.026h.049v.025h.011v-.025h.049v.065c0 .012-.01.021-.022.021l.003.086h.015c.014 0 .025.012.025.027a.026.026 0 01-.024.026c.006.006.014.007.014.015a.026.026 0 01-.023.026l.019.164c.014 0 .025.013.025.029s-.011.029-.026.029h-.482c-.015 0-.026-.013-.026-.029zm.021 1.103c0-.008.008-.01.013-.015a.025.025 0 01-.023-.025c0-.015.011-.027.025-.027h.014l.003-.088c-.012-.001-.022-.009-.022-.02v-.061l.005-.003H6.806v.025h.011v-.026h.049v.025h.011v-.025h.049v.065c0 .012-.01.021-.022.021l.003.086h.017l.008-.176a.022.022 0 01-.023-.022V9.49l.005-.003H6.958v.025h.011v-.025h.05v.025h.011v-.025h.05v.065c0 .013-.01.022-.023.022h-.002l.008.176h.017l.003-.087c-.012-.002-.022-.01-.022-.021v-.061l.005-.003H7.109v.025h.011v-.026h.049v.025h.011v-.025h.049v.065c0 .012-.01.021-.022.021l.003.086h.015c.014 0 .025.012.025.027a.026.026 0 01-.024.026c.006.006.014.007.014.015a.026.026 0 01-.023.026l.019.164c.014 0 .025.013.025.029s-.011.029-.026.029h-.482c-.014 0-.026-.013-.026-.029s.011-.03.026-.03h.001l.018-.163c-.013 0-.024-.011-.024-.026zm.57.508V8.776h.007l1.942.004.004.004V10.183l-.001.146a.955.955 0 01-.287.689.969.969 0 01-1.377-.004.982.982 0 01-.288-.689z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M6.661 8.122l-.002 2.198h.014l.002-2.184 3.235.001V10.329c-.002.427-.17.829-.475 1.132a1.614 1.614 0 01-2.286-.003 1.598 1.598 0 01-.477-1.137v-.001l-.007.001-.007.001c0 .431.171.839.481 1.147.31.309.72.479 1.153.479.435 0 .845-.169 1.153-.477s.479-.715.479-1.148v-2.2l-3.263-.001z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M7.606 11.013a.97.97 0 001.664-.685l.001-.148V8.781l-.004-.002-1.942-.004h-.007v1.549c0 .256.105.507.288.689zm-.273-.688V8.79l1.925.004v1.388l-.001.148a.938.938 0 01-.283.678.957.957 0 01-.681.282.956.956 0 01-.675-.286.964.964 0 01-.285-.679z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M6.994 8.524s-.099.024-.105.161h.035a.125.125 0 01.035-.085c.001-.002.001-.005.003-.006.003-.003.004-.014.007-.017 0 0 .019-.016.026-.015.005 0 .067.033.071.122h.036c-.008-.128-.107-.16-.108-.16z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M6.768 8.684h.103c.003-.079.036-.122.064-.145a.096.096 0 01.027-.016h-.176l-.018.161zM7.059 8.547a.191.191 0 01.06.137h.104l-.02-.162h-.18a.169.169 0 01.036.025z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M6.888 8.684c.006-.136.106-.16.105-.161.001 0 .1.032.108.161h.135l-.019-.163-.001.002h-.013l.019.162h-.103a.192.192 0 00-.06-.138.169.169 0 00-.036-.025h-.06c-.009.005-.018.009-.027.017-.028.022-.062.066-.064.145h-.103l.017-.161h-.013l-.001-.001-.018.162h.134z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M6.753 8.699c-.006 0-.011.007-.011.015s.005.015.011.015h.484c.006 0 .011-.007.011-.015s-.006-.015-.012-.015h-.483z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M7.236 8.743c.014 0 .026-.013.026-.029s-.011-.029-.025-.029h-.171l.002.006v.007h-.14v-.007h-.007c0-.003.002-.003.003-.006h-.171c-.014 0-.026.013-.026.029s.011.029.026.029h.483zm0-.044c.006 0 .011.007.011.015s-.005.015-.011.015h-.483c-.006 0-.011-.007-.011-.015s.005-.015.011-.015h.483z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M6.959 8.6c.001-.001.001-.005.003-.006-.002.001-.002.004-.003.006zM6.993 8.577c-.01.006-.054.034-.057.106h.118c-.004-.072-.049-.1-.061-.106z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M6.995 8.562c-.007-.001-.026.015-.026.015-.003.003-.004.014-.007.017-.002.001-.002.005-.003.006a.124.124 0 00-.035.084c0 .003-.003.003-.003.006h.007v.007h.139v-.006l-.002-.006c-.004-.09-.065-.123-.07-.123zm-.059.121c.003-.073.047-.101.058-.106.012.006.057.034.06.106h-.118z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M6.752 8.454c0 .007.005.013.011.013h.464c.006 0 .011-.006.011-.013 0-.007-.005-.013-.011-.013h-.464c-.006 0-.011.006-.011.013z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M6.773 8.468h.444c.006 0 .007.008.011.013.012-.001.023-.012.023-.027s-.011-.027-.025-.027h-.015l.001.014h-.133v-.014h-.017l.001.013h-.138l.001-.013h-.017l.001.014h-.133v-.014h-.014c-.014 0-.025.012-.025.027 0 .014.011.025.024.026.004-.004.004-.012.011-.012zm.454-.027c.006 0 .011.006.011.013 0 .007-.005.013-.011.013h-.464c-.006 0-.011-.006-.011-.013 0-.007.005-.013.011-.013h.464z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M7.216 8.508c.005 0 .01-.006.01-.013s-.005-.013-.01-.013h-.443c-.005 0-.01.006-.01.013s.005.013.01.013h.443z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M6.786 8.522h.431l.001-.002a.024.024 0 00.022-.025c0-.008-.008-.009-.013-.014-.004-.005-.005-.013-.011-.013h-.443c-.006 0-.007.008-.011.012-.006.005-.014.007-.014.015 0 .015.011.026.023.026l.001.001h.014zm-.013-.014c-.005 0-.01-.006-.01-.013s.005-.013.01-.013h.444c.005 0 .01.006.01.013s-.005.013-.01.013h-.444z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M7.067 8.229v-.05h-.022v.025h-.04v-.025h-.022v.025h-.04V8.18h-.021v.05c0 .004.004.008.009.008h.126c.005-.001.01-.003.01-.009z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M6.934 8.242l.12.001v.009h.003c.013 0 .023-.009.023-.022v-.065h-.05v.025h-.011v-.025h-.05v.025h-.011v-.025H6.914l-.005.004v.061c0 .012.011.022.023.022h.002v-.01zm-.002-.005c-.005 0-.009-.004-.009-.008v-.05h.021v.025h.04v-.025h.022v.025h.04v-.025h.022v.05c0 .005-.004.008-.009.008h-.127z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M7.048 8.426l-.007-.17h-.093l-.008.17h.108zm-.066-.119c-.001-.018.025-.018.025 0v.044h-.025v-.044z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M6.925 8.44l.138.001-.001-.014-.007-.176v-.009l-.12-.001v.01l-.009.176-.001.013zm.023-.184h.093l.007.17H6.94l.008-.17z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M6.791 8.427h.103l-.003-.085h-.097l-.003.085zm.063-.056v.034H6.83v-.034c0-.017.024-.017.024 0z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M6.776 8.441h.133v-.014l-.004-.086-.001.001h-.123l-.002-.002-.002.087-.001.014zm.115-.099l.003.085h-.103l.003-.085h.097z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M7.094 8.427h.103l-.003-.085h-.097l-.003.085zm.064-.022h-.024v-.034c0-.017.024-.018.024 0v.034z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M7.079 8.441h.133l-.001-.014-.003-.086-.001.001h-.123l-.002-.002-.002.087-.001.014zm.115-.099l.003.085h-.103l.003-.085h.097z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M6.905 8.327c.004 0 .008-.002.008-.008v-.05h-.021v.025h-.039v-.025h-.021v.025h-.039V8.27h-.02v.05c0 .004.004.008.009.008h.123z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M6.905 8.342s0-.001 0 0c.013-.001.022-.01.022-.022v-.065h-.049v.026h-.011v-.026h-.049v.026h-.011v-.025H6.764l-.006.003v.061c0 .011.01.019.021.021l.002.002h.124zm-.132-.072h.02v.025h.039v-.026h.021v.025h.039v-.025h.021v.05a.008.008 0 01-.008.008h-.124c-.005 0-.009-.004-.009-.008l.001-.049z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M7.208 8.327c.004 0 .008-.002.008-.008v-.05h-.021v.025h-.039v-.025h-.021v.025h-.04V8.27h-.02v.05c0 .004.004.008.009.008h.124z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M7.208 8.342s0-.001 0 0c.012-.001.022-.01.022-.022v-.065h-.049v.026H7.17v-.026h-.049v.026H7.11v-.025H7.067l-.006.003v.061c0 .011.01.019.022.021l.002.002h.123zm-.133-.072h.02v.025h.039v-.026h.021v.025h.039v-.025h.021v.05a.008.008 0 01-.008.008h-.123c-.005 0-.009-.004-.009-.008V8.27zM7.007 8.307a.013.013 0 00-.025 0v.044h.025v-.044zM6.83 8.405h.024v-.034c0-.018-.024-.017-.024 0v.034zM7.134 8.371v.034h.024v-.034c0-.017-.024-.017-.024 0z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M6.959 9.922l.003-.006c.003-.004.004-.014.007-.017 0 0 .019-.016.026-.014.005 0 .067.033.071.122h.036c-.008-.128-.107-.16-.108-.161 0 0-.099.024-.105.161h.035a.127.127 0 01.035-.085z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M7.059 9.869a.19.19 0 01.059.137h.104l-.019-.162h-.18a.169.169 0 01.036.025zM6.786 9.844l-.017.161h.103c.003-.079.036-.122.064-.145a.096.096 0 01.027-.016h-.177z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M6.754 10.007h.134c.006-.136.106-.16.105-.161.001 0 .1.032.108.161h.135l-.019-.164-.001.002h-.013l.019.162h-.103a.194.194 0 00-.06-.138.169.169 0 00-.036-.025h-.06c-.009.005-.018.009-.027.017-.028.023-.061.066-.064.145h-.103l.017-.161h-.013l-.001-.001-.018.163z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M6.753 10.021c-.006 0-.011.007-.011.015s.005.015.011.015h.484c.006 0 .011-.007.011-.015s-.005-.015-.011-.015h-.484z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M7.102 10.007h-.036l.002.006v.007h-.14v-.007h-.007c0-.003.002-.003.003-.006h-.171c-.014 0-.026.013-.026.03 0 .016.011.029.026.029h.484c.014 0 .026-.013.026-.029s-.011-.029-.025-.029h-.136zm.134.014c.006 0 .011.007.011.015s-.005.015-.011.015h-.483c-.006 0-.011-.007-.011-.015s.005-.015.011-.015h.483z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d: "M6.959 9.922c.001-.001.001-.005.003-.006l-.003.006z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M6.993 9.899c-.011.006-.055.033-.058.106h.118c-.003-.072-.048-.1-.06-.106z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M6.995 9.885c-.007-.002-.026.014-.026.014-.003.003-.004.014-.007.017-.002.001-.002.005-.003.006a.127.127 0 00-.035.084c0 .003-.003.003-.003.006h.007v.007h.139v-.007l-.002-.006c-.004-.089-.065-.122-.07-.121zm.058.121h-.117c.003-.073.047-.101.058-.106.011.005.056.033.059.106z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M6.763 9.764c-.006 0-.011.006-.011.013 0 .007.005.013.011.013h.464c.006 0 .011-.006.011-.013 0-.007-.005-.013-.011-.013h-.464z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M6.773 9.79h.444c.006 0 .007.008.011.013a.026.026 0 00.023-.026c0-.015-.011-.027-.025-.027h-.015l.001.014h-.133V9.75h-.017l.001.013h-.138l.001-.013h-.017l.001.014h-.133V9.75h-.014c-.014 0-.025.012-.025.027 0 .014.011.024.024.026.004-.005.004-.013.011-.013zm.454-.026c.006 0 .011.006.011.013 0 .007-.005.013-.011.013h-.464c-.006 0-.011-.006-.011-.013 0-.007.005-.013.011-.013h.464z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M7.216 9.83c.005 0 .01-.006.01-.013 0-.007-.005-.013-.01-.013h-.443c-.005 0-.01.006-.01.013 0 .007.005.013.01.013h.443z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M6.786 9.844h.431l.001-.002c.012 0 .022-.011.022-.025 0-.008-.008-.009-.013-.014-.004-.005-.005-.013-.011-.013h-.443c-.006 0-.007.008-.011.012-.006.005-.014.007-.014.015 0 .015.011.026.023.026l.001.001h.014zm-.013-.014c-.005 0-.01-.006-.01-.013 0-.007.005-.013.01-.013h.444c.005 0 .01.006.01.013 0 .007-.005.013-.01.013h-.444z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M7.067 9.552v-.05h-.022v.025h-.04v-.026h-.022v.025h-.04v-.024h-.021v.05c0 .004.004.008.009.008h.126c.005-.001.01-.003.01-.008z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M6.934 9.564l.12.001v.009h.003c.013 0 .023-.009.023-.022v-.065h-.05v.025h-.011v-.025h-.05v.025h-.011v-.024H6.914l-.005.003v.061c0 .012.011.022.023.022h.002v-.01zm-.002-.005c-.005 0-.009-.004-.009-.008v-.05h.021v.025h.04v-.025h.022v.025h.04v-.025h.022v.05c0 .005-.004.008-.009.008h-.127z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M7.041 9.579h-.093l-.008.169h.108l-.007-.169zm-.059.051c-.001-.018.025-.018.025 0v.044h-.025V9.63z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M6.925 9.762h.138l-.001-.013-.007-.175v-.009l-.12-.001v.01l-.009.175-.001.013zm.023-.184h.093l.007.17H6.94l.008-.17z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M6.791 9.749h.103l-.003-.085h-.097l-.003.085zm.063-.022H6.83v-.034c0-.017.024-.018.024 0v.034z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M6.776 9.763h.133v-.014l-.004-.086-.001.001h-.123l-.002-.002-.002.087-.001.014zm.115-.099l.003.085h-.103l.003-.085h.097z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M7.094 9.749h.103l-.003-.085h-.097l-.003.085zm.064-.056v.034h-.024v-.034c0-.017.024-.017.024 0z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M7.079 9.763h.133l-.001-.014-.003-.086-.001.001h-.123l-.002-.002-.002.087-.001.014zm.115-.099l.003.085h-.103l.003-.085h.097z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M6.905 9.65c.004 0 .008-.002.008-.008v-.05h-.021v.026h-.039v-.026h-.021v.025h-.039v-.025h-.02v.05c0 .004.004.008.009.008h.123z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M6.905 9.664s0-.001 0 0c.013-.001.022-.01.022-.022v-.065h-.049v.026h-.011v-.026h-.049v.026h-.011v-.025H6.764l-.006.003v.061c0 .011.01.019.021.021l.002.002h.124zm-.132-.072h.02v.025h.039v-.025h.021v.025h.039v-.025h.021v.05a.008.008 0 01-.008.008h-.124c-.005 0-.009-.004-.009-.008l.001-.05z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M7.208 9.65c.004 0 .008-.002.008-.008v-.05h-.021v.026h-.039v-.026h-.021v.025h-.04v-.025h-.02v.05c0 .004.004.008.009.008h.124z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M7.208 9.664s0-.001 0 0c.012-.001.022-.01.022-.022v-.065h-.049v.026H7.17v-.026h-.049v.026H7.11v-.025H7.067l-.006.003v.061c0 .011.01.019.022.021l.002.002h.123zm-.133-.022v-.05h.02v.025h.039v-.025h.021v.025h.039v-.025h.021v.05a.008.008 0 01-.008.008h-.123c-.004 0-.009-.004-.009-.008zM7.007 9.674V9.63a.013.013 0 00-.025 0v.044h.025zM6.83 9.693v.034h.024v-.034c0-.017-.024-.017-.024 0zM7.134 9.727h.024v-.034c0-.018-.024-.017-.024 0v.034z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d: "M7.505 11.197a.19.19 0 00-.055-.023c.017.003.035.013.055.023z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M7.348 11.192s-.056.088.039.189l.026-.026a.15.15 0 01-.045-.103c.001-.013.004-.029.008-.033l.002-.001a.14.14 0 01.135.036l.025-.026c-.096-.085-.189-.037-.19-.036z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M7.303 11.464l.073-.073c-.054-.057-.062-.112-.058-.148.001-.012.005-.021.007-.031l-.125.126.103.126zM7.367 11.17a.154.154 0 01.043-.009h.008c.008 0 .022.012.032.013a.17.17 0 01.055.023c.016.008.028.003.045.018l.073-.073-.128-.1-.128.128z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M7.387 11.38c-.095-.101-.038-.189-.039-.189.001-.001.093-.048.19.036l.095-.095-.129-.101-.001.001-.009.009.128.1-.072.075c-.017-.015-.029-.01-.045-.018-.02-.01-.038-.02-.055-.023-.01-.002-.024-.013-.032-.013H7.41a.162.162 0 00-.043.009l-.042.042a.129.129 0 00-.007.031c-.004.036.004.091.058.148l-.073.073-.102-.126-.009.009h-.001l.103.127.093-.095z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M7.302 11.486c-.004.004-.003.013.003.019s.014.007.019.003l.341-.343c.004-.004.003-.013-.003-.019a.016.016 0 00-.011-.005c-.003-.001-.006.001-.008.003l-.341.342z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M7.675 11.174c.01-.01.009-.028-.003-.039a.028.028 0 00-.019-.009.023.023 0 00-.019.007l-.095.095-.025.026.006.003.005.005-.103.104-.005-.005-.003-.006-.027.025-.094.094-.001.001c-.01.01-.009.028.003.039a.031.031 0 00.022.009c.006 0 .013-.002.017-.007l.341-.342zm-.032-.031a.011.011 0 01.008-.003c.004 0 .008.002.011.005.006.006.007.014.003.019l-.341.343c-.004.004-.013.003-.019-.003s-.007-.014-.003-.019l.341-.342z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M7.386 11.23c-.004.012-.015.062.035.116l.083-.083c-.054-.05-.106-.037-.118-.033z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M7.378 11.217l-.002.001c-.004.003-.007.02-.008.033a.15.15 0 00.045.103c.002.002 0 .004.003.006l.005.005.103-.104-.005-.005-.006-.003c-.067-.059-.133-.037-.135-.036zm.043.128c-.05-.054-.039-.104-.035-.116.013-.004.064-.016.118.032l-.083.084z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M7.129 11.314c.005.005.013.006.017.002l.327-.329c.004-.004.003-.012-.002-.017a.013.013 0 00-.01-.004c-.002 0-.005 0-.007.003l-.327.329c-.004.004-.003.011.002.016z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M7.153 11.309l.312-.315c.004-.004.011.001.017.001a.026.026 0 00-.002-.035.028.028 0 00-.02-.008c-.006 0-.013.002-.017.007l-.011.011.01.009-.092.094-.01-.01-.012.012.01.009-.097.097-.009-.01-.012.013.01.009-.093.094-.01-.01-.01.01c-.01.01-.009.026.002.037a.027.027 0 00.02.008.025.025 0 00.015-.006c-.001-.006-.006-.012-.001-.017zm.301-.341a.01.01 0 01.007-.003c.004 0 .007.002.01.004.005.005.006.013.002.017l-.327.329c-.004.004-.012.003-.017-.002-.005-.005-.006-.013-.002-.017l.327-.328z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M7.494 11.023c.002-.002.002-.004.002-.006 0-.004-.002-.007-.005-.01a.014.014 0 00-.01-.004.01.01 0 00-.006.002l-.312.315c-.004.004-.003.011.002.016.005.005.012.006.016.002l.313-.315z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M7.201 11.338l.125-.126.042-.042.127-.128.009-.009.001-.001a.025.025 0 00.006-.015.027.027 0 00-.009-.02c-.006-.005-.012-.001-.019-.001-.006 0-.013-.005-.017-.001l-.312.315c-.005.005.001.011.001.018 0 .007-.004.013.001.019a.028.028 0 00.02.009.02.02 0 00.015-.006h.001l.009-.012zm-.036-.003c-.005-.005-.006-.012-.002-.016l.312-.315c.002-.002.004-.002.006-.002.003 0 .007.002.01.004.003.003.005.006.005.01 0 .002 0 .004-.002.006l-.312.315c-.005.004-.012.003-.017-.002z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M7.191 10.933l-.036-.036-.015.015.018.018-.028.029-.018-.018-.016.015.019.018-.029.028-.017-.017-.015.014.035.035.012-.001.089-.089.003-.006zM7.044 10.999V11z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M7.106 11.035l.085-.085.007.006.002-.002c.004-.005.007-.01.007-.016a.02.02 0 00-.006-.015l-.046-.046-.035.036.018.018-.008.007-.018-.018-.035.036.018.018-.008.008-.018-.018-.03.03.005.005-.005-.005-.005.006.045.045c.004.004.01.006.015.006a.023.023 0 00.017-.007l.001-.001-.006-.008zm.084-.091l-.089.089c-.003.003-.009.004-.012.001l-.035-.035.015-.015.018.018.028-.028-.018-.018.015-.015.018.018.028-.028-.018-.019.015-.015.036.035c.002.001.002.003.002.005a.01.01 0 01-.003.007z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M7.241 11.161l.076-.076-.125-.115-.066.066.115.125zm-.037-.131l.031.031-.017.018-.031-.031a.012.012 0 01.017-.018z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M7.241 11.181l.097-.097-.01-.009-.13-.118-.007-.007-.085.085.007.007.119.129.009.01zm-.049-.211l.126.115-.076.076-.115-.125.065-.066z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M7.209 11.194l-.063-.058-.068.069.058.062.073-.073zm-.068-.011l.024.024-.017.017-.023-.024a.012.012 0 01.016-.017z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M7.136 11.288l.093-.094-.01-.009-.063-.058v.001l-.087.087-.002.001.059.063.01.009zm-.058-.083l.068-.069.063.058-.073.073-.058-.062z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M7.423 10.979l-.063-.058-.068.069.058.062.073-.073zm-.068-.011l.024.024-.017.017-.024-.024c-.012-.012.005-.03.017-.017z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M7.35 11.073l.093-.094-.01-.009-.063-.059v.001l-.087.087-.002.001.059.063.01.01zm.01-.152l.063.058-.073.073-.058-.062.068-.069z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M7.047 11.205l.012-.001.087-.087v-.012l-.035-.035-.015.015.018.018-.028.027-.018-.017-.014.014.018.018-.028.028-.018-.017-.014.014z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M7.156 11.127c0-.001 0-.001 0 0 .008-.01.009-.023 0-.031l-.045-.046-.035.035.018.018-.008.007-.018-.018-.035.035.018.018-.008.008-.018-.017-.029.029.005.005-.005-.005-.004.005.045.045c.004.004.01.006.015.006a.022.022 0 00.015-.006l.002-.001.087-.087zm-.144.043l.014-.014.018.018.028-.028-.018-.018.015-.015.018.018.028-.028-.018-.018.015-.015.036.036c.004.004.002.008 0 .011l-.087.087c-.003.003-.009.004-.012.001l-.037-.035z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M7.273 10.989l.086-.087.001-.012-.036-.035-.015.015.018.018-.027.028-.018-.018-.015.014.018.018-.028.028-.017-.017-.014.014.035.035z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M7.37 10.912c0-.001-.001-.001 0 0 .008-.01.009-.023 0-.031l-.046-.046-.035.035.018.018-.007.007-.018-.018-.035.035.018.018-.008.008-.017-.017-.031.031v.006l.042.042c.004.004.01.006.015.006A.022.022 0 007.281 11l.002-.001.087-.087zm-.13.029l.018.018.028-.028-.018-.018.015-.015.017.018.028-.028-.019-.018.015-.015.036.035c.004.004.002.008 0 .011l-.087.087c-.003.003-.009.004-.012.001l-.035-.035.014-.013zM7.235 11.061l-.031-.031a.012.012 0 00-.017.018l.031.031.017-.018zM7.165 11.207l-.024-.024c-.012-.013-.029.005-.017.017l.024.024.017-.017zM7.379 10.992l-.024-.024c-.012-.013-.029.005-.017.017l.024.024.017-.017z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M8.229 8.684a.124.124 0 01.035-.084l.002-.006c.004-.003.004-.014.008-.017 0 0 .019-.016.026-.015.005 0 .067.033.071.122h.036c-.008-.128-.107-.16-.108-.16 0 0-.099.024-.105.161h.035z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M8.177 8.684c.003-.079.036-.122.064-.145.009-.008.018-.012.027-.017h-.177l-.018.162h.104zM8.424 8.684h.104l-.02-.162h-.18c.011.006.024.013.037.025a.195.195 0 01.059.137z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M8.508 8.522l.019.162h-.103a.191.191 0 00-.06-.137.169.169 0 00-.036-.025h-.06c-.009.005-.018.009-.027.017-.028.022-.062.066-.064.145h-.103l.017-.161h-.014l-.002-.002-.016.163h.135c.006-.136.105-.16.105-.16.001 0 .1.032.108.161h.135l-.02-.164-.001.002h-.013z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M8.057 8.699c-.006 0-.011.007-.011.015s.005.015.011.015h.484c.006 0 .011-.007.011-.015s-.005-.015-.011-.015h-.484z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M8.407 8.684h-.036l.002.006v.007h-.14v-.006h-.007c0-.003.002-.003.003-.006H8.057c-.014 0-.026.013-.026.029s.012.029.026.029h.484c.014 0 .026-.013.026-.029s-.011-.029-.025-.029h-.135zm.134.015c.006 0 .011.007.011.015s-.005.015-.011.015h-.484c-.006 0-.011-.007-.011-.015s.005-.015.011-.015h.484z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M8.298 8.577c-.011.006-.054.034-.057.106h.118c-.004-.072-.049-.1-.061-.106zM8.264 8.6l.002-.006-.002.006z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M8.299 8.562c-.006-.001-.025.015-.025.015-.004.003-.004.014-.008.017l-.002.006a.124.124 0 00-.035.084c0 .003-.003.003-.003.006h.007v.007h.139V8.69l-.002-.006c-.004-.089-.066-.122-.071-.122zm-.058.121c.003-.073.047-.101.058-.106.012.006.057.034.06.106h-.118z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M8.068 8.441c-.006 0-.011.006-.011.013 0 .007.005.013.011.013h.464c.006 0 .011-.006.011-.013 0-.007-.005-.013-.011-.013h-.464z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M8.368 8.441L8.23 8.44l.001-.013h-.018v.014H8.08v-.014h-.012c-.014 0-.025.012-.025.027 0 .014.011.025.024.026.004-.004.005-.013.011-.013h.444c.006 0 .007.008.011.013.012 0 .023-.011.023-.026s-.011-.027-.025-.027h-.015l.001.014h-.133v-.014h-.017l.001.014zm.163 0c.006 0 .011.006.011.013 0 .007-.005.013-.011.013h-.463c-.006 0-.011-.006-.011-.013 0-.007.005-.013.011-.013h.463z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M8.521 8.482h-.444c-.005 0-.01.006-.01.013s.005.013.01.013h.444c.005 0 .01-.006.01-.013s-.005-.013-.01-.013z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M8.521 8.468h-.444c-.006 0-.007.008-.011.013-.005.004-.013.006-.013.014 0 .014.01.024.023.026l.002.002h.444l.001-.002a.026.026 0 00.023-.026c0-.008-.008-.009-.013-.014-.005-.005-.006-.013-.012-.013zm-.444.04c-.005 0-.01-.006-.01-.013s.005-.013.01-.013h.444c.005 0 .01.006.01.013s-.005.013-.01.013h-.444z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M8.372 8.229v-.05H8.35v.025h-.04v-.025h-.022v.025h-.04V8.18h-.021v.05c0 .004.004.008.009.008h.126c.005-.001.01-.003.01-.009z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M8.263 8.165H8.219l-.005.004v.061c0 .012.011.022.023.022h.001v-.01l.12.001v.009h.003c.013 0 .023-.009.023-.022v-.065h-.05v.025h-.01v-.025h-.05v.025h-.011v-.025zm-.026.072c-.005 0-.009-.004-.009-.008v-.05h.021v.025h.04v-.025h.022v.025h.04v-.025h.022v.05c0 .005-.004.008-.009.008h-.127z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M8.346 8.256h-.093l-.008.17h.108l-.007-.17zm-.059.051c-.001-.018.025-.018.025 0v.044h-.025v-.044z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M8.359 8.242l-.12-.001v.01l-.008.176-.001.013.138.001-.001-.014-.007-.176-.001-.009zm-.006.184h-.108l.008-.17h.093l.007.17z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M8.096 8.427h.103l-.003-.085h-.097l-.003.085zm.039-.022v-.034c0-.017.024-.018.024 0v.034h-.024z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M8.081 8.441h.133v-.014l-.004-.086-.001.001h-.123l-.002-.002-.002.087-.001.014zm.115-.099l.003.085h-.103l.003-.085h.097z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M8.399 8.427h.103l-.003-.085h-.097l-.003.085zm.063-.022h-.023v-.034c0-.017.024-.018.024 0v.034z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M8.384 8.441h.133l-.001-.014-.003-.086-.001.001h-.123l-.002-.001-.002.086-.001.014zm.115-.099l.003.085h-.103l.003-.085h.097z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M8.21 8.327c.004 0 .008-.002.008-.008v-.05h-.021v.025h-.039v-.025h-.021v.025h-.04V8.27h-.02v.05c0 .004.004.008.009.008h.124z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M8.21 8.342s0-.001 0 0c.013-.001.022-.01.022-.022v-.065h-.049v.026h-.011v-.026h-.049v.026h-.011v-.025H8.069l-.006.003v.061c0 .011.01.019.022.021l.002.002h.123zm-.132-.023v-.05h.02v.025h.039v-.025h.021v.025h.039v-.025h.021v.05a.008.008 0 01-.008.008h-.124a.008.008 0 01-.008-.008z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M8.389 8.327h.123c.004 0 .008-.002.008-.008v-.05h-.021v.025H8.46v-.025h-.021v.025H8.4V8.27h-.02v.05c0 .004.005.007.009.007z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M8.389 8.342h.123l.001-.001a.021.021 0 00.022-.021v-.065h-.049v.026h-.011v-.026h-.049v.026h-.011v-.025H8.372l-.006.003v.061c0 .011.01.019.022.021l.001.001zM8.38 8.27h.02v.025h.04v-.026h.021v.025H8.5v-.025h.021v.05a.008.008 0 01-.008.008h-.124c-.005 0-.009-.004-.009-.008V8.27zM8.287 8.351h.025v-.044c0-.018-.026-.018-.025 0v.044zM8.159 8.371c0-.018-.024-.017-.024 0v.034h.024v-.034zM8.439 8.371v.034h.024v-.034c0-.017-.024-.017-.024 0z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M9.597 8.562c.005-.001.024.014.025.015.003.003.004.014.007.017.001.001.001.005.003.006a.127.127 0 01.035.084h.035c-.006-.136-.106-.16-.107-.16 0 0-.099.032-.107.16h.036c.006-.089.068-.122.073-.122z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M9.719 8.684h.103l-.017-.162h-.177c.009.005.018.009.027.016.028.023.061.067.064.146zM9.472 8.684a.191.191 0 01.059-.137.15.15 0 01.037-.025h-.181l-.018.162h.103z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M9.805 8.522l.017.161h-.103c-.003-.078-.036-.122-.064-.144-.009-.008-.018-.012-.027-.017h-.06c-.011.006-.024.013-.037.025a.191.191 0 00-.059.137h-.103l.019-.162h-.013l-.001-.001-.02.164h.135c.008-.128.107-.16.107-.16.001 0 .101.024.107.16h.134l-.018-.164-.001.001h-.013z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M9.354 8.699c-.006 0-.011.007-.011.015s.005.015.011.015h.484c.006 0 .011-.007.011-.015s-.005-.015-.011-.015h-.484z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M9.702 8.684h-.035c0 .003.003.003.003.006v.007h-.147V8.69l.002-.006h-.171c-.014 0-.025.013-.025.029s.012.029.026.029h.484c.014 0 .026-.013.026-.029s-.012-.029-.026-.029h-.137zm.136.015c.006 0 .011.007.011.015s-.005.015-.011.015h-.484c-.006 0-.011-.007-.011-.015s.005-.015.011-.015h.484z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M9.597 8.577c-.009.005-.057.032-.06.106h.118c-.003-.073-.048-.1-.058-.106zM9.629 8.594c.001.001.001.005.003.006-.002-.001-.002-.005-.003-.006z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M9.629 8.594c-.003-.003-.004-.014-.007-.017 0 0-.019-.015-.025-.015-.006 0-.068.033-.072.122l-.002.006v.007h.147V8.69c0-.003-.002-.003-.003-.006a.127.127 0 00-.035-.084c-.002-.001-.002-.005-.003-.006zm-.092.089c.003-.075.051-.102.06-.106.01.005.055.033.058.106h-.118z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M9.364 8.441c-.006 0-.011.006-.011.013 0 .007.005.013.011.013h.464c.006 0 .011-.006.011-.013 0-.007-.005-.013-.011-.013h-.464z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M9.665 8.44l-.137.001.001-.013h-.018v.014h-.133l.001-.014h-.015c-.014 0-.025.012-.025.027 0 .014.011.025.024.026.004-.004.005-.013.011-.013h.444c.006 0 .007.008.011.013a.026.026 0 00.024-.026c0-.015-.011-.027-.025-.027h-.014v.014h-.133l.001-.014h-.017v.012zm.163.001c.006 0 .011.006.011.013 0 .007-.005.013-.011.013h-.464c-.006 0-.011-.006-.011-.013 0-.007.005-.013.011-.013h.464z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M9.818 8.482h-.443c-.005 0-.01.006-.01.013s.005.013.01.013h.444c.005 0 .01-.006.01-.013s-.006-.013-.011-.013z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M9.818 8.468h-.443c-.006 0-.007.008-.011.013-.006.005-.014.006-.014.014 0 .014.011.025.023.026l.001.001h.444l.001-.001a.025.025 0 00.023-.026c0-.008-.008-.01-.013-.015-.004-.004-.005-.012-.011-.012zm-.443.04c-.005 0-.01-.006-.01-.013s.005-.013.01-.013h.444c.005 0 .01.006.01.013s-.005.013-.01.013h-.444z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M9.668 8.229v-.05h-.021v.025h-.04v-.025h-.022v.025h-.04v-.025h-.021v.05c0 .005.004.008.009.008h.126c.004 0 .009-.004.009-.008z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M9.51 8.229c0 .013.01.022.023.022h.003v-.009l.12-.001v.01h.002c.013 0 .023-.01.023-.022v-.061l-.004-.003h-.044v.025h-.012v-.025h-.05v.025H9.56v-.025h-.05v.064zm.023.008c-.004 0-.009-.002-.009-.008v-.05h.022v.025h.04v-.025h.022v.025h.04V8.18h.021v.05c0 .004-.004.008-.009.008h-.127z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M9.643 8.256H9.55l-.007.17h.108l-.008-.17zm-.059.051c0-.018.025-.018.025 0v.044h-.025v-.044z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M9.657 8.242l-.12.001v.009l-.009.175v.014l.137-.001v-.013l-.008-.176v-.009zm-.007.184h-.108l.007-.17h.093l.008.17z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M9.696 8.427h.103l-.002-.085H9.7l-.004.085zm.064-.056v.034h-.023v-.034c0-.017.024-.017.023 0z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M9.682 8.441h.133v-.014l-.004-.087-.002.001h-.123l-.001-.001-.003.087v.014zm.115-.099l.003.085h-.103l.003-.085h.097z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M9.394 8.427h.103l-.003-.085h-.097l-.003.085zm.063-.022h-.024v-.034c0-.018.024-.017.024 0v.034z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M9.379 8.441h.133v-.014l-.004-.087-.002.002h-.123l-.001-.001-.003.086v.014zm.115-.099l.003.085h-.103l.003-.085h.097z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M9.809 8.327c.005 0 .009-.004.009-.008v-.05h-.02v.025h-.039v-.025h-.021v.025h-.039v-.025h-.021v.05c0 .005.004.008.008.008h.123z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M9.809 8.342l.002-.001c.011-.002.021-.01.021-.021v-.061l-.005-.003h-.044v.025h-.01v-.026h-.049v.025h-.011v-.025h-.049v.065c0 .012.01.021.022.021l.001.001h.122zm-.131-.073h.021v.025h.039v-.025h.021v.025h.039V8.27h.02v.05c0 .004-.004.008-.009.008h-.123c-.004 0-.008-.002-.008-.008v-.051z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M9.506 8.327c.005 0 .009-.004.009-.008v-.05h-.02v.025h-.039v-.025h-.021v.025h-.039v-.025h-.021v.05c0 .005.004.008.008.008h.123z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M9.506 8.342l.002-.002c.011-.001.021-.009.021-.02v-.061l-.004-.003h-.044v.025H9.47v-.026h-.049v.025H9.41v-.025h-.049v.065c0 .012.01.021.022.021l.001.001h.122zm-.131-.073h.021v.025h.039v-.025h.021v.025h.039V8.27h.02v.05c0 .004-.004.008-.009.008h-.123c-.004 0-.008-.002-.008-.008v-.051zM9.608 8.307c.001-.018-.025-.018-.025 0v.044h.025v-.044zM9.737 8.405h.023v-.034c0-.017-.024-.018-.024 0v.034zM9.433 8.371v.034h.024v-.034c0-.017-.024-.017-.024 0z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M9.597 9.884c.005-.001.024.014.025.015.003.003.004.014.007.017.001.002.001.005.003.006a.127.127 0 01.035.084h.035c-.006-.136-.106-.16-.107-.16 0 0-.099.032-.107.16h.036c.006-.088.068-.122.073-.122z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M9.719 10.006h.103l-.017-.162h-.177c.009.005.018.009.027.016a.19.19 0 01.064.146zM9.472 10.006a.193.193 0 01.059-.137c.013-.012.026-.019.037-.025h-.181l-.019.162h.104z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M9.805 9.844l.017.161h-.103a.186.186 0 00-.064-.144c-.009-.008-.018-.012-.027-.017h-.06c-.011.006-.024.013-.037.025a.19.19 0 00-.059.137h-.103l.019-.162h-.013l-.001-.001-.019.164h.135c.008-.128.107-.16.107-.16.001 0 .101.024.107.16h.134l-.019-.164-.001.001h-.013z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M9.354 10.021c-.006 0-.011.007-.011.015s.005.015.011.015h.484c.006 0 .011-.007.011-.015s-.005-.015-.011-.015h-.484z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M9.702 10.007h-.035c0 .003.003.003.003.006v.007h-.147v-.007l.002-.006h-.171c-.014 0-.025.013-.025.029s.012.029.026.029h.484c.014 0 .026-.013.026-.029s-.012-.03-.026-.03h-.137zm.136.014c.006 0 .011.007.011.015s-.005.015-.011.015h-.484c-.006 0-.011-.007-.011-.015s.005-.015.011-.015h.484z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M9.629 9.916c.001.001.001.005.003.006-.002-.001-.002-.004-.003-.006zM9.597 9.899c-.009.005-.057.032-.06.106h.118c-.003-.073-.048-.1-.058-.106z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M9.629 9.916c-.003-.003-.004-.014-.007-.017 0 0-.019-.016-.025-.015-.006 0-.068.033-.072.122l-.002.006v.007h.147v-.007c0-.003-.002-.003-.003-.006a.127.127 0 00-.035-.084c-.002-.001-.002-.005-.003-.006zm-.092.09c.003-.075.051-.102.06-.106.01.005.055.033.058.106h-.118z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M9.353 9.777c0 .007.005.013.011.013h.464c.006 0 .011-.006.011-.013 0-.007-.005-.013-.011-.013h-.464c-.006 0-.011.006-.011.013z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M9.665 9.762h-.138l.001-.013h-.017v.014h-.133l.001-.014h-.015c-.014 0-.025.012-.025.027 0 .014.011.025.024.026.004-.004.005-.012.012-.012h.444c.006 0 .007.008.011.013a.026.026 0 00.024-.026c0-.015-.011-.027-.025-.027h-.015v.014h-.133l.001-.014h-.017v.012zm.163.002c.006 0 .011.006.011.013 0 .007-.005.013-.011.013h-.464c-.006 0-.011-.006-.011-.013 0-.007.005-.013.011-.013h.464z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M9.818 9.804h-.443c-.005 0-.01.006-.01.013 0 .007.005.013.01.013h.444c.005 0 .01-.006.01-.013-.001-.007-.006-.013-.011-.013z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M9.818 9.79h-.443c-.006 0-.007.008-.011.013-.006.005-.014.006-.014.014 0 .014.011.025.023.026l.001.001h.444l.001-.001a.025.025 0 00.023-.026c0-.008-.008-.01-.013-.015-.004-.004-.005-.012-.011-.012zm-.443.04c-.005 0-.01-.006-.01-.013 0-.007.005-.013.01-.013h.444c.005 0 .01.006.01.013 0 .007-.005.013-.01.013h-.444z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M9.668 9.551v-.05h-.021v.025h-.04v-.025h-.022v.025h-.04v-.025h-.021v.05c0 .005.004.008.009.008h.126c.004 0 .009-.003.009-.008z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M9.677 9.488h-.044v.025h-.012v-.026h-.05v.025H9.56v-.025h-.05v.065c0 .013.01.022.023.022h.003v-.009l.12-.001v.01h.002c.013 0 .023-.01.023-.022v-.061l-.004-.003zm-.144.071c-.004 0-.009-.002-.009-.008v-.05h.022v.025h.04v-.025h.022v.025h.04v-.024h.021v.05c0 .004-.004.008-.009.008h-.127z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M9.643 9.578H9.55l-.007.17h.108l-.008-.17zm-.059.052c0-.018.025-.018.025 0v.044h-.025V9.63z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M9.657 9.564l-.12.001v.009l-.009.175v.014h.138l-.001-.014-.008-.175v-.01zm-.007.184h-.108l.007-.17h.093l.008.17z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M9.696 9.749h.103l-.002-.085H9.7l-.004.085zm.064-.022h-.023v-.034c0-.018.024-.017.024 0v.034z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M9.682 9.763h.133v-.014l-.004-.087-.002.001h-.123l-.001-.001-.003.087v.014zm.115-.099l.003.085h-.103l.003-.085h.097z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M9.394 9.749h.103l-.003-.085h-.097l-.003.085zm.063-.022h-.024v-.034c0-.018.024-.017.024 0v.034z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M9.379 9.763h.133v-.014l-.004-.087-.002.002h-.123l-.001-.001-.003.086v.014zm.115-.099l.003.085h-.103l.003-.085h.097z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M9.686 9.65h.123c.005 0 .009-.004.009-.008v-.05h-.02v.025h-.039v-.025h-.021v.025h-.039v-.025h-.021v.05c0 .005.004.008.008.008z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M9.809 9.664l.002-.001c.011-.001.022-.009.022-.021v-.061l-.006-.003h-.044v.025h-.01v-.026h-.049v.025h-.011v-.025h-.049v.065c0 .012.01.021.022.021l.001.001h.122zm-.11-.072v.026h.039v-.026h.021v.025h.039v-.025h.02v.05c0 .004-.004.008-.009.008h-.123c-.004 0-.008-.002-.008-.008v-.05h.021z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M9.506 9.65c.005 0 .009-.004.009-.008v-.05h-.02v.025h-.039v-.025h-.021v.025h-.039v-.025h-.021v.05c0 .005.004.008.008.008h.123z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M9.506 9.664l.002-.002c.011-.001.021-.009.021-.021V9.58l-.004-.002h-.044v.025H9.47v-.026h-.049v.025H9.41v-.025h-.049v.065c0 .012.009.021.022.021l.001.001h.122zm-.131-.022v-.05h.021v.026h.039v-.026h.021v.025h.039v-.025h.02v.05c0 .004-.004.008-.009.008h-.123a.008.008 0 01-.008-.008zM9.608 9.674V9.63c.001-.018-.025-.018-.025 0v.044h.025zM9.737 9.693v.034h.023v-.034c.001-.017-.023-.017-.023 0zM9.433 9.693v.034h.024v-.034c0-.017-.024-.017-.024 0z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M9.213 11.217l.002.001c.004.003.007.02.008.033a.15.15 0 01-.045.103l.026.026c.095-.101.038-.189.038-.19 0 0-.093-.047-.189.037l.025.026c.067-.059.132-.037.135-.036z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M9.273 11.243c.004.036-.004.091-.058.148l.073.073.102-.126-.125-.126c.003.01.007.019.008.031zM8.968 11.142l.073.073a.19.19 0 01.14-.054.162.162 0 01.043.009l-.127-.128-.129.1z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M9.39 11.338l-.102.126-.073-.073c.054-.057.062-.112.058-.148-.001-.012-.005-.021-.008-.031l-.042-.042a.154.154 0 00-.043-.009.193.193 0 00-.14.054l-.073-.073.128-.1-.009-.009-.001-.001-.129.101.095.095c.096-.085.189-.037.189-.037.001.001.057.089-.038.19l.094.094.103-.127h-.001l-.008-.01z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M8.948 11.143a.01.01 0 00-.007-.003H8.94a.016.016 0 00-.011.005c-.006.006-.007.014-.003.019l.341.343c.004.004.013.003.019-.003s.007-.014.003-.019l-.341-.342z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M9.204 11.38l-.026-.026c-.002.002 0 .004-.003.006l-.005.006-.103-.104.005-.005.006-.003-.025-.026-.095-.095a.026.026 0 00-.019-.007.034.034 0 00-.019.009c-.012.011-.013.029-.003.039l.341.343a.023.023 0 00.017.007.031.031 0 00.022-.009c.012-.011.013-.029.003-.039l-.001-.001-.095-.095zm.084.106c.004.004.003.013-.003.019s-.014.007-.019.003l-.341-.343c-.004-.004-.003-.013.003-.019a.016.016 0 01.011-.005h.001a.01.01 0 01.007.003l.341.342z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M9.205 11.23c-.013-.004-.064-.017-.118.032l.083.083c.05-.054.039-.104.035-.115z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M9.223 11.251c-.001-.013-.004-.029-.008-.033l-.002-.001c-.003-.001-.069-.024-.135.036l-.006.003-.005.005.103.104.005-.005.003-.006a.148.148 0 00.045-.103zm-.136.011c.054-.049.105-.036.118-.032.004.012.015.062-.035.116l-.083-.084z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M9.462 11.314c.005-.005.006-.013.002-.017l-.327-.329c-.002-.002-.005-.002-.007-.003-.004 0-.007.002-.01.004-.005.005-.006.013-.002.017l.327.329c.004.005.012.004.017-.001z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M9.454 11.288l-.093-.094.01-.009-.012-.012-.009.01-.097-.097.01-.009-.013-.014-.01.01-.093-.094.01-.009-.011-.011a.024.024 0 00-.017-.007.03.03 0 00-.02.008c-.008.008-.005.019-.001.029.006 0 .013.002.017.006l.312.315c.005.005-.001.011-.001.018a.02.02 0 00.015.006.032.032 0 00.02-.008.027.027 0 00.002-.037l-.01-.01-.009.009zm-.336-.301c-.004-.004-.003-.012.002-.017a.013.013 0 01.01-.004c.002 0 .005 0 .007.003l.327.329c.004.004.003.012-.002.017-.005.005-.013.006-.017.002l-.327-.33z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M9.116 11.004c-.002-.002-.004-.002-.006-.002h-.001a.015.015 0 00-.009.004c-.003.003-.005.006-.005.01 0 .002 0 .004.002.006l.313.315c.004.004.011.003.016-.002.005-.005.006-.012.002-.016l-.312-.315z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M9.438 11.309l-.312-.315a.024.024 0 00-.017-.006h-.001a.037.037 0 00-.018.008.028.028 0 00-.009.02.02.02 0 00.006.015l.001.001.009.009.127.128.042.042.125.126.009.011h.001c.004.004.01.006.015.006a.028.028 0 00.02-.009c.005-.005.001-.012.001-.019 0-.006.006-.012.001-.017zm-.012.026c-.005.005-.012.006-.016.002l-.313-.315c-.002-.002-.002-.004-.002-.006 0-.004.002-.007.005-.01a.012.012 0 01.009-.004h.001c.002 0 .004 0 .006.002l.312.315c.004.004.003.011-.002.016z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M9.501 11.034l.036-.035-.015-.014-.018.017-.028-.028.018-.018-.015-.015-.018.018-.028-.029.018-.018-.015-.015-.036.036-.002.005.003.006.088.089z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M9.399 10.95l.085.085-.007.007.001.001a.023.023 0 00.017.007.02.02 0 00.015-.006L9.554 11l-.002-.005-.031-.032-.018.018-.008-.008.018-.018-.035-.036-.018.018-.007-.007.018-.018-.035-.036-.046.046a.03.03 0 00-.007.015c0 .006.003.012.007.016l.002.002.007-.005zm.002-.006l-.003-.006.002-.005.036-.035.015.015-.018.017.028.028.018-.018.015.015-.018.018.028.028.018-.018.015.015-.035.035c-.003.003-.009.002-.012-.001l-.089-.088z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M9.35 11.161l.115-.125-.066-.066-.126.115.077.076zm.054-.114l-.031.031-.017-.018.031-.031c.012-.012.03.006.017.018z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M9.253 11.084l.097.097.009-.01.119-.129.007-.007-.086-.085-.007.006-.13.118-.009.01zm.212-.048l-.115.125-.076-.076.126-.115.065.066z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M9.381 11.194l.073.073.058-.062-.068-.069-.063.058zm.085.006l-.024.024-.017-.017.024-.024c.013-.012.029.005.017.017z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M9.435 11.127c-.001-.001 0-.001 0 0l-.063.057-.01.009.093.094.01-.01.059-.063-.002-.001-.087-.086zm.077.078l-.058.062-.073-.073.063-.058.068.069z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M9.168 10.979l.073.073.058-.062-.068-.069-.063.058zm.084.006l-.024.024-.017-.017.024-.024c.013-.013.029.005.017.017z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M9.148 10.979l.093.094.01-.01L9.31 11l-.002-.001-.087-.087v-.001l-.063.058-.01.01zm.151.011l-.058.062-.073-.073.063-.058.068.069z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M9.519 11.145l.018-.018-.015-.014-.018.017-.027-.027.018-.018-.015-.015-.036.035.001.012.086.087.012.001.036-.035-.015-.014-.017.017z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M9.557 11.127l-.035-.035-.018.018-.008-.008.018-.018-.034-.034-.046.046c-.009.009-.008.021 0 .031v.001l.087.087.002.001c.004.004.01.006.015.006a.02.02 0 00.015-.006l.042-.042v-.006l-.031-.031-.018.017-.008-.008.019-.019zm-.01.046l.018-.018.014.014-.035.035a.008.008 0 01-.012-.001l-.087-.087c-.003-.003-.004-.007 0-.011l.035-.035.015.015-.018.018.028.028.018-.018.015.015-.018.018.027.027z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FF0",
          d:
            "M9.318 10.989l.012.001.035-.035-.014-.014-.018.017-.027-.028.018-.018-.015-.014-.018.018-.028-.028.018-.018-.014-.015-.036.035v.012z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M9.308 10.999L9.31 11c.004.004.01.006.015.006A.02.02 0 009.34 11l.042-.041.002-.006-.032-.032-.018.017-.008-.008.018-.018-.035-.035-.018.018-.008-.008.018-.018-.035-.035-.045.046c-.009.009-.008.021 0 .031v.001l.087.087zm-.077-.109l.036-.035.015.015-.018.018.028.028.018-.018.015.015-.019.017.028.028.018-.018.014.014-.036.036a.008.008 0 01-.012-.001l-.087-.087c-.002-.003-.004-.008 0-.012zM9.373 11.078l.031-.031c.013-.012-.005-.031-.017-.018l-.031.031.017.018zM9.425 11.207l.017.017.024-.024c.012-.012-.004-.029-.017-.017l-.024.024zM9.228 11.009l.024-.024c.012-.012-.004-.029-.017-.017l-.024.024.017.017z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#039",
          d:
            "M8.089 9.764l-.001.307c0 .063.024.121.063.162a.207.207 0 00.151.068.204.204 0 00.151-.068.237.237 0 00.063-.162v-.306l-.427-.001zm.055.351c0-.023.019-.042.042-.042.023 0 .042.019.042.042s-.019.042-.042.042a.042.042 0 01-.042-.042zm.161-.162c.023 0 .042.019.042.042 0 .023-.019.042-.042.042s-.042-.019-.042-.042a.041.041 0 01.042-.042zm-.119-.114c.023 0 .042.019.042.042a.042.042 0 01-.042.042.042.042 0 01-.042-.042c0-.023.019-.042.042-.042zm.237.318a.042.042 0 01-.042-.042c0-.023.019-.042.042-.042.023 0 .042.019.042.042a.041.041 0 01-.042.042zm.001-.233a.042.042 0 010-.085c.023 0 .042.019.042.042s-.019.043-.042.043z"
        }
      }),
      _c("circle", {
        attrs: { cx: "8.186", cy: "9.881", r: ".042", fill: "#FFF" }
      }),
      _c("circle", {
        attrs: { cx: "8.424", cy: "9.881", r: ".042", fill: "#FFF" }
      }),
      _c("circle", {
        attrs: { cx: "8.305", cy: "9.995", r: ".042", fill: "#FFF" }
      }),
      _c("circle", {
        attrs: { cx: "8.186", cy: "10.115", r: ".042", fill: "#FFF" }
      }),
      _c("circle", {
        attrs: { cx: "8.423", cy: "10.114", r: ".042", fill: "#FFF" }
      }),
      _c("path", {
        attrs: {
          fill: "#039",
          d:
            "M8.151 9.491a.204.204 0 00.303 0 .234.234 0 00.063-.162v-.307h-.428l-.001.307c0 .063.024.121.063.162zm.035-.395a.042.042 0 010 .085c-.023 0-.042-.019-.042-.042s.019-.043.042-.043zm-.042.276c0-.023.019-.042.042-.042.023 0 .042.019.042.042a.042.042 0 01-.042.042.042.042 0 01-.042-.042zm.161-.162c.023 0 .042.019.042.042s-.019.043-.042.043-.043-.019-.043-.042.019-.043.043-.043zm.118.204c-.023 0-.042-.019-.042-.042s.019-.043.042-.043a.042.042 0 010 .085zm.043-.275a.042.042 0 01-.042.042.042.042 0 01-.042-.042c0-.023.019-.042.042-.042a.041.041 0 01.042.042z"
        }
      }),
      _c("circle", {
        attrs: { cx: "8.186", cy: "9.138", r: ".042", fill: "#FFF" }
      }),
      _c("path", {
        attrs: {
          fill: "#FFF",
          d:
            "M8.424 9.096a.042.042 0 00-.042.042c0 .023.019.042.042.042a.042.042 0 00.042-.042.042.042 0 00-.042-.042z"
        }
      }),
      _c("circle", {
        attrs: { cx: "8.305", cy: "9.253", r: ".042", fill: "#FFF" }
      }),
      _c("circle", {
        attrs: { cx: "8.186", cy: "9.372", r: ".042", fill: "#FFF" }
      }),
      _c("circle", {
        attrs: { cx: "8.423", cy: "9.372", r: ".042", fill: "#FFF" }
      }),
      _c("path", {
        attrs: {
          fill: "#039",
          d:
            "M7.709 10.302a.204.204 0 00.151-.068.237.237 0 00.063-.162v-.307h-.428l-.001.307c0 .063.024.121.063.162a.207.207 0 00.152.068zm.079-.421c0-.023.019-.042.042-.042s.042.019.042.042-.019.043-.042.043-.042-.019-.042-.043zm-.077.157a.042.042 0 01-.042-.042c0-.023.019-.042.042-.042s.042.019.042.042a.042.042 0 01-.042.042zm.119.119a.042.042 0 01-.042-.042c0-.023.019-.042.042-.042s.042.019.042.042a.042.042 0 01-.042.042zm-.195-.276c0 .023-.019.042-.042.042s-.043-.019-.043-.042c0-.023.019-.042.042-.042s.043.019.043.042zm-.042.191c.023 0 .042.019.042.042s-.019.042-.042.042-.043-.018-.043-.041.019-.043.043-.043z"
        }
      }),
      _c("circle", {
        attrs: { cx: "7.593", cy: "9.881", r: ".042", fill: "#FFF" }
      }),
      _c("circle", {
        attrs: { cx: "7.83", cy: "9.881", r: ".042", fill: "#FFF" }
      }),
      _c("circle", {
        attrs: { cx: "7.711", cy: "9.995", r: ".042", fill: "#FFF" }
      }),
      _c("circle", {
        attrs: { cx: "7.593", cy: "10.115", r: ".042", fill: "#FFF" }
      }),
      _c("circle", {
        attrs: { cx: "7.83", cy: "10.114", r: ".042", fill: "#FFF" }
      }),
      _c("path", {
        attrs: {
          fill: "#039",
          d:
            "M8.681 9.764l-.001.307c0 .063.024.121.063.162a.207.207 0 00.151.068.204.204 0 00.151-.068.237.237 0 00.063-.162v-.306l-.427-.001zm.097.393c-.023 0-.042-.019-.042-.042s.019-.042.042-.042c.023 0 .042.019.042.042s-.018.042-.042.042zm0-.233a.042.042 0 01-.042-.042c0-.023.019-.042.042-.042.023 0 .042.019.042.042a.042.042 0 01-.042.042zm.119.114a.042.042 0 01-.042-.042c0-.023.019-.042.042-.042s.042.019.042.042a.042.042 0 01-.042.042zm.119.119a.042.042 0 01-.042-.042c0-.023.019-.042.042-.042.023 0 .042.019.042.042a.042.042 0 01-.042.042zm.042-.276a.042.042 0 01-.085 0c0-.024.019-.042.042-.042s.043.019.043.042z"
        }
      }),
      _c("circle", {
        attrs: { cx: "8.778", cy: "9.881", r: ".042", fill: "#FFF" }
      }),
      _c("circle", {
        attrs: { cx: "9.016", cy: "9.881", r: ".042", fill: "#FFF" }
      }),
      _c("circle", {
        attrs: { cx: "8.897", cy: "9.995", r: ".042", fill: "#FFF" }
      }),
      _c("circle", {
        attrs: { cx: "8.778", cy: "10.115", r: ".042", fill: "#FFF" }
      }),
      _c("circle", {
        attrs: { cx: "9.016", cy: "10.114", r: ".042", fill: "#FFF" }
      }),
      _c("path", {
        attrs: {
          fill: "#039",
          d:
            "M8.517 10.501h-.428l-.001.307c0 .063.024.121.063.162a.207.207 0 00.151.068.204.204 0 00.151-.068.237.237 0 00.063-.162v-.307zm-.212.188c.023 0 .042.019.042.042s-.019.042-.042.042-.042-.019-.042-.042.018-.042.042-.042zm-.161-.072c0-.023.019-.042.042-.042.023 0 .042.019.042.042a.042.042 0 01-.042.042.042.042 0 01-.042-.042zm.322 0a.042.042 0 01-.042.042c-.023 0-.042-.019-.042-.042s.019-.042.042-.042c.023 0 .042.019.042.042zm-.28.276a.042.042 0 01-.042-.042c0-.023.019-.042.042-.042.023 0 .042.019.042.042a.041.041 0 01-.042.042zm.28-.043a.042.042 0 01-.042.042.042.042 0 01-.042-.042c0-.023.019-.042.042-.042.023 0 .042.019.042.042z"
        }
      }),
      _c("circle", {
        attrs: { cx: "8.186", cy: "10.617", r: ".042", fill: "#FFF" }
      }),
      _c("circle", {
        attrs: { cx: "8.424", cy: "10.617", r: ".042", fill: "#FFF" }
      }),
      _c("circle", {
        attrs: { cx: "8.305", cy: "10.731", r: ".042", fill: "#FFF" }
      }),
      _c("circle", {
        attrs: { cx: "8.186", cy: "10.851", r: ".042", fill: "#FFF" }
      }),
      _c("circle", {
        attrs: { cx: "8.423", cy: "10.85", r: ".042", fill: "#FFF" }
      }),
      _c("g", { attrs: { fill: "none" } }, [
        _c("circle", { attrs: { cx: "10", cy: "10", r: "9" } }),
        _c("circle", {
          attrs: { cx: "10", cy: "10", r: "9.5", stroke: "#E4E4E4" }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }